export const translationKeys = {
  comboHowManyDoYouWant: "combo.how.many.do.you.want",
  comboFiltersLabels: "combo.filters.labels",
  wedoWedoFamily: "wedo.wedoFamily",
  wedoWedoFamilyPlural: "wedo.wedoFamily.plural",
  wedoSalat: "wedo.salat",
  startTitleWefeatorganic: "start.title.wefeatorganic",
  startTitleWefeat: "start.title.wefeat",
  startTitleWedo: "start.title.wedo",
  startTitleTsutsu: "start.title.tsutsu",
  startTitleSmag: "start.title.smag",
  startTitlePalaeo: "start.title.palaeo",
  startTitleOlioli: "start.title.olioli",
  startTitleMaexico: "start.title.maexico",
  startTitleKunguak: "start.title.kunguak",
  startTitleKcalfactory: "start.title.kcalfactory",
  startTitleJagger: "start.title.jagger",
  startTitleHumblepie: "start.title.humblepie",
  startTitleHubb: "start.title.hubb",
  startTitleGroednorway: "start.title.groednorway",
  startTitleGroed: "start.title.groed",
  startTitleGorms: "start.title.gorms",
  startTitleGarbanzo: "start.title.garbanzo",
  startTitleFrankies: "start.title.frankies",
  startTitleEdenjaxx: "start.title.edenjaxx",
  startTitleCocorico: "start.title.cocorico",
  startTitleCaspers: "start.title.caspers",
  startTitleBuzzcph: "start.title.buzzcph",
  startTitleBurgerbeast: "start.title.burgerbeast",
  startTitleBoff: "start.title.boff",
  startTitleBlokksmash: "start.title.blokksmash",
  startTitleBiteline: "start.title.biteline",
  startTitleBindia: "start.title.bindia",
  startTitleWaldorfGroup: "start.title.Waldorf.Group",
  startTitleTommis: "start.title.Tommis",
  startTitleTheFatGreek: "start.title.TheFatGreek",
  startTitleStrangas: "start.title.Strangas",
  startTitleStacys: "start.title.Stacys",
  startTitleShabaz: "start.title.Shabaz",
  startTitleSandwichpigen: "start.title.Sandwichpigen",
  startTitleSURTX: "start.title.SURT2",
  startTitleRollneat: "start.title.Rollneat",
  startTitleRaSushi: "start.title.RaSushi",
  startTitlePureGreensClub: "start.title.PureGreensClub",
  startTitlePicopizza: "start.title.Picopizza",
  startTitleParadis: "start.title.Paradis",
  startTitlePanzanella: "start.title.Panzanella",
  startTitlePHAGO: "start.title.PHAGO",
  startTitleOAKBERRY: "start.title.OAKBERRY",
  startTitleNOAHS: "start.title.NOAHS",
  startTitleMubanthai: "start.title.Mubanthai",
  startTitleMaikai: "start.title.Maikai",
  startTitleMadklubben: "start.title.Madklubben",
  startTitleMaMeMi: "start.title.MaMeMi",
  startTitleLighthouseburger: "start.title.Lighthouseburger",
  startTitleLetzsushi: "start.title.Letzsushi",
  startTitleKyllingCo: "start.title.KyllingCo",
  startTitleKillerkebab: "start.title.Killerkebab",
  startTitleIscafeen: "start.title.Iscafeen",
  startTitleIRONWOK: "start.title.IRONWOK",
  startTitleIKISUSHI: "start.title.IKISUSHI",
  startTitleHellopasta: "start.title.Hellopasta",
  startTitleGoldenroost: "start.title.Goldenroost",
  startTitleGeppetto: "start.title.Geppetto",
  startTitleGaodumpling: "start.title.Gaodumpling",
  startTitleFrederiksbergSmørrebrød: "start.title.Frederiksberg.Smørrebrød",
  startTitleFlyChicken: "start.title.FlyChicken",
  startTitleEvald: "start.title.Evald",
  startTitleDistrictTonkin: "start.title.DistrictTonkin",
  startTitleDiamondSlice: "start.title.DiamondSlice",
  startTitleDhaba: "start.title.Dhaba",
  startTitleDandelion: "start.title.Dandelion",
  startTitleChavez: "start.title.Chavez",
  startTitleBurgerShack: "start.title.BurgerShack",
  startTitleBuka: "start.title.Buka",
  startTitleBaryl: "start.title.Baryl",
  startTitleBanhBanh: "start.title.BanhBanh",
  startTitleBONES: "start.title.BONES",
  startTitleBADSHA: "start.title.BADSHA",
  startTitleANOTHERPIZZA: "start.title.ANOTHERPIZZA",
  startSneakPeek: "start.sneakPeek",
  startLoginHighlight: "start.loginHighlight",
  startLogin: "start.login",
  startDescriptionWefeatorganic: "start.description.wefeatorganic",
  startDescriptionWefeat: "start.description.wefeat",
  startDescriptionWedo: "start.description.wedo",
  startDescriptionTsutsu: "start.description.tsutsu",
  startDescriptionSmag: "start.description.smag",
  startDescriptionPalaeo: "start.description.palaeo",
  startDescriptionOlioli: "start.description.olioli",
  startDescriptionMaexico: "start.description.maexico",
  startDescriptionKunguak: "start.description.kunguak",
  startDescriptionKcalfactory: "start.description.kcalfactory",
  startDescriptionJagger: "start.description.jagger",
  startDescriptionHumblepie: "start.description.humblepie",
  startDescriptionHubb: "start.description.hubb",
  startDescriptionGroednorway: "start.description.groednorway",
  startDescriptionGroed: "start.description.groed",
  startDescriptionGorms: "start.description.gorms",
  startDescriptionGarbanzo: "start.description.garbanzo",
  startDescriptionFrankies: "start.description.frankies",
  startDescriptionEdenjaxx: "start.description.edenjaxx",
  startDescriptionCocorico: "start.description.cocorico",
  startDescriptionCaspers: "start.description.caspers",
  startDescriptionBuzzcph: "start.description.buzzcph",
  startDescriptionBurgerbeast: "start.description.burgerbeast",
  startDescriptionBoff: "start.description.boff",
  startDescriptionBlokksmash: "start.description.blokksmash",
  startDescriptionBiteline: "start.description.biteline",
  startDescriptionBindia: "start.description.bindia",
  startDescriptionWaldorfGroup: "start.description.Waldorf.Group",
  startDescriptionTommis: "start.description.Tommis",
  startDescriptionTheFatGreek: "start.description.TheFatGreek",
  startDescriptionStrangas: "start.description.Strangas",
  startDescriptionStacys: "start.description.Stacys",
  startDescriptionShabaz: "start.description.Shabaz",
  startDescriptionSandwichpigen: "start.description.Sandwichpigen",
  startDescriptionSURTX: "start.description.SURT2",
  startDescriptionRollneat: "start.description.Rollneat",
  startDescriptionRaSushi: "start.description.RaSushi",
  startDescriptionPureGreensClub: "start.description.PureGreensClub",
  startDescriptionPicopizza: "start.description.Picopizza",
  startDescriptionParadis: "start.description.Paradis",
  startDescriptionPanzanella: "start.description.Panzanella",
  startDescriptionPHAGO: "start.description.PHAGO",
  startDescriptionOAKBERRY: "start.description.OAKBERRY",
  startDescriptionNOAHS: "start.description.NOAHS",
  startDescriptionMubanthai: "start.description.Mubanthai",
  startDescriptionMaikai: "start.description.Maikai",
  startDescriptionMadklubben: "start.description.Madklubben",
  startDescriptionMaMeMi: "start.description.MaMeMi",
  startDescriptionLighthouseburger: "start.description.Lighthouseburger",
  startDescriptionLetzsushi: "start.description.Letzsushi",
  startDescriptionKyllingCo: "start.description.KyllingCo",
  startDescriptionKillerkebab: "start.description.Killerkebab",
  startDescriptionIscafeen: "start.description.Iscafeen",
  startDescriptionIRONWOK: "start.description.IRONWOK",
  startDescriptionIKISUSHI: "start.description.IKISUSHI",
  startDescriptionHellopasta: "start.description.Hellopasta",
  startDescriptionGoldenroost: "start.description.Goldenroost",
  startDescriptionGeppetto: "start.description.Geppetto",
  startDescriptionGaodumpling: "start.description.Gaodumpling",
  startDescriptionFrederiksbergSmørrebrød:
    "start.description.Frederiksberg.Smørrebrød",
  startDescriptionFlyChicken: "start.description.FlyChicken",
  startDescriptionEvald: "start.description.Evald",
  startDescriptionDistrictTonkin: "start.description.DistrictTonkin",
  startDescriptionDiamondSlice: "start.description.DiamondSlice",
  startDescriptionDhaba: "start.description.Dhaba",
  startDescriptionDandelion: "start.description.Dandelion",
  startDescriptionChavez: "start.description.Chavez",
  startDescriptionBurgerShack: "start.description.BurgerShack",
  startDescriptionBuka: "start.description.Buka",
  startDescriptionBaryl: "start.description.Baryl",
  startDescriptionBanhBanh: "start.description.BanhBanh",
  startDescriptionBONES: "start.description.BONES",
  startDescriptionBADSHA: "start.description.BADSHA",
  startDescriptionANOTHERPIZZA: "start.description.ANOTHERPIZZA",
  referralCtaTitleWefeatorganic: "referral.cta.title.wefeatorganic",
  referralCtaTitleWefeat: "referral.cta.title.wefeat",
  referralCtaTitleWedo: "referral.cta.title.wedo",
  referralCtaTitleTsutsu: "referral.cta.title.tsutsu",
  referralCtaTitleSmag: "referral.cta.title.smag",
  referralCtaTitlePalaeo: "referral.cta.title.palaeo",
  referralCtaTitleOlioli: "referral.cta.title.olioli",
  referralCtaTitleMaexico: "referral.cta.title.maexico",
  referralCtaTitleKcalfactory: "referral.cta.title.kcalfactory",
  referralCtaTitleJagger: "referral.cta.title.jagger",
  referralCtaTitleHumblepie: "referral.cta.title.humblepie",
  referralCtaTitleHubb: "referral.cta.title.hubb",
  referralCtaTitleGroed: "referral.cta.title.groed",
  referralCtaTitleGorms: "referral.cta.title.gorms",
  referralCtaTitleGarbanzo: "referral.cta.title.garbanzo",
  referralCtaTitleFrankies: "referral.cta.title.frankies",
  referralCtaTitleEdenjaxx: "referral.cta.title.edenjaxx",
  referralCtaTitleCocorico: "referral.cta.title.cocorico",
  referralCtaTitleCaspers: "referral.cta.title.caspers",
  referralCtaTitleBuzzcph: "referral.cta.title.buzzcph",
  referralCtaTitleBurgerbeast: "referral.cta.title.burgerbeast",
  referralCtaTitleBoff: "referral.cta.title.boff",
  referralCtaTitleBlokksmash: "referral.cta.title.blokksmash",
  referralCtaTitleBiteline: "referral.cta.title.biteline",
  referralCtaTitleBindia: "referral.cta.title.bindia",
  referralCtaTitleWaldorfGroup: "referral.cta.title.Waldorf.Group",
  referralCtaTitleTheFatGreek: "referral.cta.title.TheFatGreek",
  referralCtaTitleStrangas: "referral.cta.title.Strangas",
  referralCtaTitleStacys: "referral.cta.title.Stacys",
  referralCtaTitleShabaz: "referral.cta.title.Shabaz",
  referralCtaTitleSandwichpigen: "referral.cta.title.Sandwichpigen",
  referralCtaTitleSURTX: "referral.cta.title.SURT2",
  referralCtaTitleRollneat: "referral.cta.title.Rollneat",
  referralCtaTitleRaSushi: "referral.cta.title.RaSushi",
  referralCtaTitlePicopizza: "referral.cta.title.Picopizza",
  referralCtaTitleParadis: "referral.cta.title.Paradis",
  referralCtaTitleOAKBERRY: "referral.cta.title.OAKBERRY",
  referralCtaTitleNOAHS: "referral.cta.title.NOAHS",
  referralCtaTitleMubanthai: "referral.cta.title.Mubanthai",
  referralCtaTitleMadklubben: "referral.cta.title.Madklubben",
  referralCtaTitleMaMeMi: "referral.cta.title.MaMeMi",
  referralCtaTitleLighthouseburger: "referral.cta.title.Lighthouseburger",
  referralCtaTitleLetzsushi: "referral.cta.title.Letzsushi",
  referralCtaTitleKyllingCo: "referral.cta.title.KyllingCo",
  referralCtaTitleKillerkebab: "referral.cta.title.Killerkebab",
  referralCtaTitleIscafeen: "referral.cta.title.Iscafeen",
  referralCtaTitleIRONWOK: "referral.cta.title.IRONWOK",
  referralCtaTitleIKISUSHI: "referral.cta.title.IKISUSHI",
  referralCtaTitleHellopasta: "referral.cta.title.Hellopasta",
  referralCtaTitleGoldenroost: "referral.cta.title.Goldenroost",
  referralCtaTitleGeppetto: "referral.cta.title.Geppetto",
  referralCtaTitleGaodumpling: "referral.cta.title.Gaodumpling",
  referralCtaTitleFrederiksbergSmørrebrød:
    "referral.cta.title.Frederiksberg.Smørrebrød",
  referralCtaTitleDistrictTonkin: "referral.cta.title.DistrictTonkin",
  referralCtaTitleDiamondSlice: "referral.cta.title.DiamondSlice",
  referralCtaTitleDhaba: "referral.cta.title.Dhaba",
  referralCtaTitleDandelion: "referral.cta.title.Dandelion",
  referralCtaTitleChavez: "referral.cta.title.Chavez",
  referralCtaTitleBurgerShack: "referral.cta.title.BurgerShack",
  referralCtaTitleBaryl: "referral.cta.title.Baryl",
  referralCtaTitleBanhBanh: "referral.cta.title.BanhBanh",
  referralCtaTitleBONES: "referral.cta.title.BONES",
  referralCtaTitleBADSHA: "referral.cta.title.BADSHA",
  referralCtaTitleANOTHERPIZZA: "referral.cta.title.ANOTHERPIZZA",
  referralCtaMessageWefeat: "referral.cta.message.wefeat",
  referralCtaMessagePalaeo: "referral.cta.message.palaeo",
  referralCtaMessageKcalfactory: "referral.cta.message.kcalfactory",
  referralCtaMessageJagger: "referral.cta.message.jagger",
  referralCtaMessageGarbanzo: "referral.cta.message.garbanzo",
  referralCtaMessageBuzzcph: "referral.cta.message.buzzcph",
  referralCtaActionWefeatorganic: "referral.cta.action.wefeatorganic",
  referralCtaActionTsutsu: "referral.cta.action.tsutsu",
  referralCtaActionSmag: "referral.cta.action.smag",
  referralCtaActionMaexico: "referral.cta.action.maexico",
  referralCtaActionJagger: "referral.cta.action.jagger",
  referralCtaActionHumblepie: "referral.cta.action.humblepie",
  referralCtaActionHubb: "referral.cta.action.hubb",
  referralCtaActionGorms: "referral.cta.action.gorms",
  referralCtaActionFrankies: "referral.cta.action.frankies",
  referralCtaActionEdenjaxx: "referral.cta.action.edenjaxx",
  referralCtaActionCocorico: "referral.cta.action.cocorico",
  referralCtaActionCaspers: "referral.cta.action.caspers",
  referralCtaActionBuzzcph: "referral.cta.action.buzzcph",
  referralCtaActionBurgerbeast: "referral.cta.action.burgerbeast",
  referralCtaActionBoff: "referral.cta.action.boff",
  referralCtaActionBlokksmash: "referral.cta.action.blokksmash",
  referralCtaActionBiteline: "referral.cta.action.biteline",
  referralCtaActionBindia: "referral.cta.action.bindia",
  referralCtaActionWaldorfGroup: "referral.cta.action.Waldorf.Group",
  referralCtaActionTommis: "referral.cta.action.Tommis",
  referralCtaActionTheFatGreek: "referral.cta.action.TheFatGreek",
  referralCtaActionStrangas: "referral.cta.action.Strangas",
  referralCtaActionStacys: "referral.cta.action.Stacys",
  referralCtaActionShabaz: "referral.cta.action.Shabaz",
  referralCtaActionSandwichpigen: "referral.cta.action.Sandwichpigen",
  referralCtaActionSURTX: "referral.cta.action.SURT2",
  referralCtaActionRollneat: "referral.cta.action.Rollneat",
  referralCtaActionRaSushi: "referral.cta.action.RaSushi",
  referralCtaActionPureGreensClub: "referral.cta.action.PureGreensClub",
  referralCtaActionParadis: "referral.cta.action.Paradis",
  referralCtaActionPanzanella: "referral.cta.action.Panzanella",
  referralCtaActionPHAGO: "referral.cta.action.PHAGO",
  referralCtaActionOAKBERRY: "referral.cta.action.OAKBERRY",
  referralCtaActionNOAHS: "referral.cta.action.NOAHS",
  referralCtaActionMubanthai: "referral.cta.action.Mubanthai",
  referralCtaActionMaikai: "referral.cta.action.Maikai",
  referralCtaActionMadklubben: "referral.cta.action.Madklubben",
  referralCtaActionMaMeMi: "referral.cta.action.MaMeMi",
  referralCtaActionLighthouseburger: "referral.cta.action.Lighthouseburger",
  referralCtaActionLetzsushi: "referral.cta.action.Letzsushi",
  referralCtaActionKyllingCo: "referral.cta.action.KyllingCo",
  referralCtaActionKillerkebab: "referral.cta.action.Killerkebab",
  referralCtaActionIscafeen: "referral.cta.action.Iscafeen",
  referralCtaActionIRONWOK: "referral.cta.action.IRONWOK",
  referralCtaActionIKISUSHI: "referral.cta.action.IKISUSHI",
  referralCtaActionHelleopasta: "referral.cta.action.Helleopasta",
  referralCtaActionGoldenroost: "referral.cta.action.Goldenroost",
  referralCtaActionGeppetto: "referral.cta.action.Geppetto",
  referralCtaActionGaodumpling: "referral.cta.action.Gaodumpling",
  referralCtaActionFrederiksbergSmørrebrød:
    "referral.cta.action.Frederiksberg.Smørrebrød",
  referralCtaActionFlyChicken: "referral.cta.action.FlyChicken",
  referralCtaActionEvald: "referral.cta.action.Evald",
  referralCtaActionDistrictTonkin: "referral.cta.action.DistrictTonkin",
  referralCtaActionDiamondSlice: "referral.cta.action.DiamondSlice",
  referralCtaActionDhaba: "referral.cta.action.Dhaba",
  referralCtaActionDandelion: "referral.cta.action.Dandelion",
  referralCtaActionChavez: "referral.cta.action.Chavez",
  referralCtaActionBurgerShack: "referral.cta.action.BurgerShack",
  referralCtaActionBaryl: "referral.cta.action.Baryl",
  referralCtaActionBanhBanh: "referral.cta.action.BanhBanh",
  referralCtaActionBONES: "referral.cta.action.BONES",
  referralCtaActionBADSHA: "referral.cta.action.BADSHA",
  referralCtaActionANOTHERPIZZA: "referral.cta.action.ANOTHERPIZZA",
  orderToTableCtaAreYouAtRestaurant: "orderToTable.cta.areYouAtRestaurant",
  homeSectionTitleVouchers: "home.section.title.vouchers",
  homeCtaGetDiscountCardTitleWedo: "home.cta.getDiscountCard.title.wedo",
  homeCtaGetDiscountCardTitlePalaeo: "home.cta.getDiscountCard.title.palaeo",
  homeCtaGetDiscountCardTitleOlioli: "home.cta.getDiscountCard.title.olioli",
  homeCtaGetDiscountCardTitleMamemi: "home.cta.getDiscountCard.title.mamemi",
  homeCtaGetDiscountCardTitleMaexico: "home.cta.getDiscountCard.title.maexico",
  homeCtaGetDiscountCardTitleKcalfactory:
    "home.cta.getDiscountCard.title.kcalfactory",
  homeCtaGetDiscountCardTitleJagger: "home.cta.getDiscountCard.title.jagger",
  homeCtaGetDiscountCardTitleHubb: "home.cta.getDiscountCard.title.hubb",
  homeCtaGetDiscountCardTitleGroed: "home.cta.getDiscountCard.title.groed",
  homeCtaGetDiscountCardTitleGorms: "home.cta.getDiscountCard.title.gorms",
  homeCtaGetDiscountCardTitleFrankies:
    "home.cta.getDiscountCard.title.frankies",
  homeCtaGetDiscountCardTitleDistrictTonkin:
    "home.cta.getDiscountCard.title.districtTonkin",
  homeCtaGetDiscountCardTitleCocorico:
    "home.cta.getDiscountCard.title.cocorico",
  homeCtaGetDiscountCardTitleRaSushi: "home.cta.getDiscountCard.title.RaSushi",
  homeCtaGetDiscountCardDescriptionWedo:
    "home.cta.getDiscountCard.description.wedo",
  homeCtaGetDiscountCardDescriptionPalaeo:
    "home.cta.getDiscountCard.description.palaeo",
  homeCtaGetDiscountCardDescriptionOlioli:
    "home.cta.getDiscountCard.description.olioli",
  homeCtaGetDiscountCardDescriptionMamemi:
    "home.cta.getDiscountCard.description.mamemi",
  homeCtaGetDiscountCardDescriptionMaexico:
    "home.cta.getDiscountCard.description.maexico",
  homeCtaGetDiscountCardDescriptionKcalfactory:
    "home.cta.getDiscountCard.description.kcalfactory",
  homeCtaGetDiscountCardDescriptionJagger:
    "home.cta.getDiscountCard.description.jagger",
  homeCtaGetDiscountCardDescriptionHubb:
    "home.cta.getDiscountCard.description.hubb",
  homeCtaGetDiscountCardDescriptionGroed:
    "home.cta.getDiscountCard.description.groed",
  homeCtaGetDiscountCardDescriptionGorms:
    "home.cta.getDiscountCard.description.gorms",
  homeCtaGetDiscountCardDescriptionFrankies:
    "home.cta.getDiscountCard.description.frankies",
  homeCtaGetDiscountCardDescriptionDistrictTonkin:
    "home.cta.getDiscountCard.description.districtTonkin",
  homeCtaGetDiscountCardDescriptionCocorico:
    "home.cta.getDiscountCard.description.cocorico",
  homeCtaGetDiscountCardDescriptionRaSushi:
    "home.cta.getDiscountCard.description.RaSushi",
  homeCtaGetDiscountCard: "home.cta.getDiscountCard",
  homeCtaBuyVouchersTitleWefeat: "home.cta.buyVouchers.title.wefeat",
  homeCtaBuyVouchersTitleWedo: "home.cta.buyVouchers.title.wedo",
  homeCtaBuyVouchersTitleSmag: "home.cta.buyVouchers.title.smag",
  homeCtaBuyVouchersTitlePuregreensclub:
    "home.cta.buyVouchers.title.puregreensclub",
  homeCtaBuyVouchersTitleOlioli: "home.cta.buyVouchers.title.olioli",
  homeCtaBuyVouchersTitleKunguak: "home.cta.buyVouchers.title.kunguak",
  homeCtaBuyVouchersTitleKcal: "home.cta.buyVouchers.title.kcal",
  homeCtaBuyVouchersTitleJagger: "home.cta.buyVouchers.title.jagger",
  homeCtaBuyVouchersTitleHubb: "home.cta.buyVouchers.title.hubb",
  homeCtaBuyVouchersTitleGroed: "home.cta.buyVouchers.title.groed",
  homeCtaBuyVouchersTitleFrankies: "home.cta.buyVouchers.title.frankies",
  homeCtaBuyVouchersTitleEdenjaxx: "home.cta.buyVouchers.title.edenjaxx",
  homeCtaBuyVouchersTitleTommis: "home.cta.buyVouchers.title.Tommis",
  homeCtaBuyVouchersTitlePanzanella: "home.cta.buyVouchers.title.Panzanella",
  homeCtaBuyVouchersTitleMaikai: "home.cta.buyVouchers.title.Maikai",
  homeCtaBuyVouchersTitleKyllingCo: "home.cta.buyVouchers.title.KyllingCo",
  homeCtaBuyVouchersTitleFlyChicken: "home.cta.buyVouchers.title.FlyChicken",
  homeCtaBuyVouchersTitleEvald: "home.cta.buyVouchers.title.Evald",
  homeCtaBuyVouchersDescriptionWefeat:
    "home.cta.buyVouchers.description.wefeat",
  homeCtaBuyVouchersDescriptionWedo: "home.cta.buyVouchers.description.wedo",
  homeCtaBuyVouchersDescriptionSmag: "home.cta.buyVouchers.description.smag",
  homeCtaBuyVouchersDescriptionPuregreensclub:
    "home.cta.buyVouchers.description.puregreensclub",
  homeCtaBuyVouchersDescriptionOlioli:
    "home.cta.buyVouchers.description.olioli",
  homeCtaBuyVouchersDescriptionKunguak:
    "home.cta.buyVouchers.description.kunguak",
  homeCtaBuyVouchersDescriptionKcal: "home.cta.buyVouchers.description.kcal",
  homeCtaBuyVouchersDescriptionJagger:
    "home.cta.buyVouchers.description.jagger",
  homeCtaBuyVouchersDescriptionHubb: "home.cta.buyVouchers.description.hubb",
  homeCtaBuyVouchersDescriptionGroed: "home.cta.buyVouchers.description.groed",
  homeCtaBuyVouchersDescriptionFrankies:
    "home.cta.buyVouchers.description.frankies",
  homeCtaBuyVouchersDescriptionEdenjaxx:
    "home.cta.buyVouchers.description.edenjaxx",
  homeCtaBuyVouchersDescriptionTommis:
    "home.cta.buyVouchers.description.Tommis",
  homeCtaBuyVouchersDescriptionPanzanella:
    "home.cta.buyVouchers.description.Panzanella",
  homeCtaBuyVouchersDescriptionMaikai:
    "home.cta.buyVouchers.description.Maikai",
  homeCtaBuyVouchersDescriptionKyllingCo:
    "home.cta.buyVouchers.description.KyllingCo",
  homeCtaBuyVouchersDescriptionFlyChicken:
    "home.cta.buyVouchers.description.FlyChicken",
  homeCtaBuyVouchersDescriptionEvald: "home.cta.buyVouchers.description.Evald",
  homeCtaBuyVouchersDescription: "home.cta.buyVouchers.description",
  homeCtaBookTableRestaurantPickerTitle:
    "home.cta.bookTable.restaurantPickerTitle",
  homeCtaBookTableCardTitle: "home.cta.bookTable.cardTitle",
  homeBrandsSectionHeader: "home.brands.sectionHeader",
  homeBrandsExploreAll: "home.brands.exploreAll",
  homeBookTable: "home.bookTable",
  homeActionOrderTakeAway: "home.action.orderTakeAway",
  homeAction: "home.action",
  heapsgoVenuedetailsOpensAtTomorrow: "heapsgo.venuedetails.opensAtTomorrow",
  heapsgoVenuedetailsOpensAtToday: "heapsgo.venuedetails.opensAtToday",
  heapsgoVenuedetailsOpensAtDay: "heapsgo.venuedetails.opensAtDay",
  heapsgoVenueMenuQuantity: "heapsgo.venue.menu.quantity",
  heapsgoVenueAway: "heapsgo.venue.away",
  heapsgoTableBookingVenueListTitle: "heapsgo.tableBooking.venueList.title",
  heapsgoReferralOverviewTitle: "heapsgo.referralOverview.title",
  heapsgoReferralOverviewTicketTitleWefeatorganic:
    "heapsgo.referralOverview.ticketTitle.wefeatorganic",
  heapsgoReferralOverviewTicketTitleWefeat:
    "heapsgo.referralOverview.ticketTitle.wefeat",
  heapsgoReferralOverviewTicketTitleWedo:
    "heapsgo.referralOverview.ticketTitle.wedo",
  heapsgoReferralOverviewTicketTitleTsutsu:
    "heapsgo.referralOverview.ticketTitle.tsutsu",
  heapsgoReferralOverviewTicketTitleSmag:
    "heapsgo.referralOverview.ticketTitle.smag",
  heapsgoReferralOverviewTicketTitlePalaeo:
    "heapsgo.referralOverview.ticketTitle.palaeo",
  heapsgoReferralOverviewTicketTitleOlioli:
    "heapsgo.referralOverview.ticketTitle.olioli",
  heapsgoReferralOverviewTicketTitleMaexico:
    "heapsgo.referralOverview.ticketTitle.maexico",
  heapsgoReferralOverviewTicketTitleKcalfactory:
    "heapsgo.referralOverview.ticketTitle.kcalfactory",
  heapsgoReferralOverviewTicketTitleJagger:
    "heapsgo.referralOverview.ticketTitle.jagger",
  heapsgoReferralOverviewTicketTitleHumblepie:
    "heapsgo.referralOverview.ticketTitle.humblepie",
  heapsgoReferralOverviewTicketTitleHubb:
    "heapsgo.referralOverview.ticketTitle.hubb",
  heapsgoReferralOverviewTicketTitleGroed:
    "heapsgo.referralOverview.ticketTitle.groed",
  heapsgoReferralOverviewTicketTitleGorms:
    "heapsgo.referralOverview.ticketTitle.gorms",
  heapsgoReferralOverviewTicketTitleGarbanzo:
    "heapsgo.referralOverview.ticketTitle.garbanzo",
  heapsgoReferralOverviewTicketTitleFrankies:
    "heapsgo.referralOverview.ticketTitle.frankies",
  heapsgoReferralOverviewTicketTitleEdenjaxx:
    "heapsgo.referralOverview.ticketTitle.edenjaxx",
  heapsgoReferralOverviewTicketTitleCocorico:
    "heapsgo.referralOverview.ticketTitle.cocorico",
  heapsgoReferralOverviewTicketTitleCaspers:
    "heapsgo.referralOverview.ticketTitle.caspers",
  heapsgoReferralOverviewTicketTitleBurgerbeast:
    "heapsgo.referralOverview.ticketTitle.burgerbeast",
  heapsgoReferralOverviewTicketTitleBoff:
    "heapsgo.referralOverview.ticketTitle.boff",
  heapsgoReferralOverviewTicketTitleBlokksmash:
    "heapsgo.referralOverview.ticketTitle.blokksmash",
  heapsgoReferralOverviewTicketTitleBiteline:
    "heapsgo.referralOverview.ticketTitle.biteline",
  heapsgoReferralOverviewTicketTitleBindia:
    "heapsgo.referralOverview.ticketTitle.bindia",
  heapsgoReferralOverviewTicketTitleWaldorfGroup:
    "heapsgo.referralOverview.ticketTitle.Waldorf.Group",
  heapsgoReferralOverviewTicketTitleTommis:
    "heapsgo.referralOverview.ticketTitle.Tommis",
  heapsgoReferralOverviewTicketTitleTheFatGreek:
    "heapsgo.referralOverview.ticketTitle.TheFatGreek",
  heapsgoReferralOverviewTicketTitleStrangas:
    "heapsgo.referralOverview.ticketTitle.Strangas",
  heapsgoReferralOverviewTicketTitleStacys:
    "heapsgo.referralOverview.ticketTitle.Stacys",
  heapsgoReferralOverviewTicketTitleShabaz:
    "heapsgo.referralOverview.ticketTitle.Shabaz",
  heapsgoReferralOverviewTicketTitleSandwichpigen:
    "heapsgo.referralOverview.ticketTitle.Sandwichpigen",
  heapsgoReferralOverviewTicketTitleSURTX:
    "heapsgo.referralOverview.ticketTitle.SURT2",
  heapsgoReferralOverviewTicketTitleRollneat:
    "heapsgo.referralOverview.ticketTitle.Rollneat",
  heapsgoReferralOverviewTicketTitleRaSushi:
    "heapsgo.referralOverview.ticketTitle.RaSushi",
  heapsgoReferralOverviewTicketTitlePureGreensClub:
    "heapsgo.referralOverview.ticketTitle.PureGreensClub",
  heapsgoReferralOverviewTicketTitleParadis:
    "heapsgo.referralOverview.ticketTitle.Paradis",
  heapsgoReferralOverviewTicketTitlePanzanella:
    "heapsgo.referralOverview.ticketTitle.Panzanella",
  heapsgoReferralOverviewTicketTitlePHAGO:
    "heapsgo.referralOverview.ticketTitle.PHAGO",
  heapsgoReferralOverviewTicketTitleOAKBERRY:
    "heapsgo.referralOverview.ticketTitle.OAKBERRY",
  heapsgoReferralOverviewTicketTitleNOAHS:
    "heapsgo.referralOverview.ticketTitle.NOAHS",
  heapsgoReferralOverviewTicketTitleMubanthai:
    "heapsgo.referralOverview.ticketTitle.Mubanthai",
  heapsgoReferralOverviewTicketTitleMaikai:
    "heapsgo.referralOverview.ticketTitle.Maikai",
  heapsgoReferralOverviewTicketTitleMadklubben:
    "heapsgo.referralOverview.ticketTitle.Madklubben",
  heapsgoReferralOverviewTicketTitleMaMeMi:
    "heapsgo.referralOverview.ticketTitle.MaMeMi",
  heapsgoReferralOverviewTicketTitleLighthouseburger:
    "heapsgo.referralOverview.ticketTitle.Lighthouseburger",
  heapsgoReferralOverviewTicketTitleLetzsushi:
    "heapsgo.referralOverview.ticketTitle.Letzsushi",
  heapsgoReferralOverviewTicketTitleKyllingCo:
    "heapsgo.referralOverview.ticketTitle.KyllingCo",
  heapsgoReferralOverviewTicketTitleKillerkebab:
    "heapsgo.referralOverview.ticketTitle.Killerkebab",
  heapsgoReferralOverviewTicketTitleIscafeen:
    "heapsgo.referralOverview.ticketTitle.Iscafeen",
  heapsgoReferralOverviewTicketTitleIRONWOK:
    "heapsgo.referralOverview.ticketTitle.IRONWOK",
  heapsgoReferralOverviewTicketTitleIKISUSHI:
    "heapsgo.referralOverview.ticketTitle.IKISUSHI",
  heapsgoReferralOverviewTicketTitleHellopasta:
    "heapsgo.referralOverview.ticketTitle.Hellopasta",
  heapsgoReferralOverviewTicketTitleGoldenroost:
    "heapsgo.referralOverview.ticketTitle.Goldenroost",
  heapsgoReferralOverviewTicketTitleGeppetto:
    "heapsgo.referralOverview.ticketTitle.Geppetto",
  heapsgoReferralOverviewTicketTitleGaodumpling:
    "heapsgo.referralOverview.ticketTitle.Gaodumpling",
  heapsgoReferralOverviewTicketTitleFrederiksbergSmørrebrød:
    "heapsgo.referralOverview.ticketTitle.Frederiksberg.Smørrebrød",
  heapsgoReferralOverviewTicketTitleFlyChicken:
    "heapsgo.referralOverview.ticketTitle.FlyChicken",
  heapsgoReferralOverviewTicketTitleEvald:
    "heapsgo.referralOverview.ticketTitle.Evald",
  heapsgoReferralOverviewTicketTitleDistrictTonkin:
    "heapsgo.referralOverview.ticketTitle.DistrictTonkin",
  heapsgoReferralOverviewTicketTitleDiamondSlice:
    "heapsgo.referralOverview.ticketTitle.DiamondSlice",
  heapsgoReferralOverviewTicketTitleDhaba:
    "heapsgo.referralOverview.ticketTitle.Dhaba",
  heapsgoReferralOverviewTicketTitleDandelion:
    "heapsgo.referralOverview.ticketTitle.Dandelion",
  heapsgoReferralOverviewTicketTitleChavez:
    "heapsgo.referralOverview.ticketTitle.Chavez",
  heapsgoReferralOverviewTicketTitleBurgerShack:
    "heapsgo.referralOverview.ticketTitle.BurgerShack",
  heapsgoReferralOverviewTicketTitleBaryl:
    "heapsgo.referralOverview.ticketTitle.Baryl",
  heapsgoReferralOverviewTicketTitleBanhBanh:
    "heapsgo.referralOverview.ticketTitle.BanhBanh",
  heapsgoReferralOverviewTicketTitleBONES:
    "heapsgo.referralOverview.ticketTitle.BONES",
  heapsgoReferralOverviewTicketTitleBADSHA:
    "heapsgo.referralOverview.ticketTitle.BADSHA",
  heapsgoReferralOverviewTicketTitleANOTHERPIZZA:
    "heapsgo.referralOverview.ticketTitle.ANOTHERPIZZA",
  heapsgoReferralOverviewShareWefeat: "heapsgo.referralOverview.share.wefeat",
  heapsgoReferralOverviewShareWedo: "heapsgo.referralOverview.share.wedo",
  heapsgoReferralOverviewShareTsutsu: "heapsgo.referralOverview.share.tsutsu",
  heapsgoReferralOverviewShareSmag: "heapsgo.referralOverview.share.smag",
  heapsgoReferralOverviewSharePalaeo: "heapsgo.referralOverview.share.palaeo",
  heapsgoReferralOverviewShareOlioli: "heapsgo.referralOverview.share.olioli",
  heapsgoReferralOverviewShareMaexico: "heapsgo.referralOverview.share.maexico",
  heapsgoReferralOverviewShareKcalfactory:
    "heapsgo.referralOverview.share.kcalfactory",
  heapsgoReferralOverviewShareJagger: "heapsgo.referralOverview.share.jagger",
  heapsgoReferralOverviewShareHumblepie:
    "heapsgo.referralOverview.share.humblepie",
  heapsgoReferralOverviewShareHubb: "heapsgo.referralOverview.share.hubb",
  heapsgoReferralOverviewShareGroed: "heapsgo.referralOverview.share.groed",
  heapsgoReferralOverviewShareGorms: "heapsgo.referralOverview.share.gorms",
  heapsgoReferralOverviewShareGarbanzo:
    "heapsgo.referralOverview.share.garbanzo",
  heapsgoReferralOverviewShareFrankies:
    "heapsgo.referralOverview.share.frankies",
  heapsgoReferralOverviewShareEdenjaxx:
    "heapsgo.referralOverview.share.edenjaxx",
  heapsgoReferralOverviewShareCocorico:
    "heapsgo.referralOverview.share.cocorico",
  heapsgoReferralOverviewShareBuzzcph: "heapsgo.referralOverview.share.buzzcph",
  heapsgoReferralOverviewShareBurgerbeast:
    "heapsgo.referralOverview.share.burgerbeast",
  heapsgoReferralOverviewShareBoff: "heapsgo.referralOverview.share.boff",
  heapsgoReferralOverviewShareBlokksmash:
    "heapsgo.referralOverview.share.blokksmash",
  heapsgoReferralOverviewShareBiteline:
    "heapsgo.referralOverview.share.biteline",
  heapsgoReferralOverviewShareBindia: "heapsgo.referralOverview.share.bindia",
  heapsgoReferralOverviewShareWaldorfGroup:
    "heapsgo.referralOverview.share.Waldorf.Group",
  heapsgoReferralOverviewShareTommis: "heapsgo.referralOverview.share.Tommis",
  heapsgoReferralOverviewShareTheFatGreek:
    "heapsgo.referralOverview.share.TheFatGreek",
  heapsgoReferralOverviewShareStrangas:
    "heapsgo.referralOverview.share.Strangas",
  heapsgoReferralOverviewShareStacys: "heapsgo.referralOverview.share.Stacys",
  heapsgoReferralOverviewShareShabaz: "heapsgo.referralOverview.share.Shabaz",
  heapsgoReferralOverviewShareSandwichpigen:
    "heapsgo.referralOverview.share.Sandwichpigen",
  heapsgoReferralOverviewShareSURTX: "heapsgo.referralOverview.share.SURT2",
  heapsgoReferralOverviewShareRollneat:
    "heapsgo.referralOverview.share.Rollneat",
  heapsgoReferralOverviewShareRaSushi: "heapsgo.referralOverview.share.RaSushi",
  heapsgoReferralOverviewSharePureGreensClub:
    "heapsgo.referralOverview.share.PureGreensClub",
  heapsgoReferralOverviewSharePicoPizza:
    "heapsgo.referralOverview.share.PicoPizza",
  heapsgoReferralOverviewShareParadis: "heapsgo.referralOverview.share.Paradis",
  heapsgoReferralOverviewSharePanzanella:
    "heapsgo.referralOverview.share.Panzanella",
  heapsgoReferralOverviewSharePHAGO: "heapsgo.referralOverview.share.PHAGO",
  heapsgoReferralOverviewShareOAKBERRY:
    "heapsgo.referralOverview.share.OAKBERRY",
  heapsgoReferralOverviewShareNOAHS: "heapsgo.referralOverview.share.NOAHS",
  heapsgoReferralOverviewShareMubanthai:
    "heapsgo.referralOverview.share.Mubanthai",
  heapsgoReferralOverviewShareMaikai: "heapsgo.referralOverview.share.Maikai",
  heapsgoReferralOverviewShareMadklubben:
    "heapsgo.referralOverview.share.Madklubben",
  heapsgoReferralOverviewShareMaMeMi: "heapsgo.referralOverview.share.MaMeMi",
  heapsgoReferralOverviewShareLighthouseburger:
    "heapsgo.referralOverview.share.Lighthouseburger",
  heapsgoReferralOverviewShareLetzsushi:
    "heapsgo.referralOverview.share.Letzsushi",
  heapsgoReferralOverviewShareKyllingCo:
    "heapsgo.referralOverview.share.KyllingCo",
  heapsgoReferralOverviewShareKillerkebab:
    "heapsgo.referralOverview.share.Killerkebab",
  heapsgoReferralOverviewShareIRONWOK: "heapsgo.referralOverview.share.IRONWOK",
  heapsgoReferralOverviewShareIKISUSHI:
    "heapsgo.referralOverview.share.IKISUSHI",
  heapsgoReferralOverviewShareHellopasta:
    "heapsgo.referralOverview.share.Hellopasta",
  heapsgoReferralOverviewShareGoldenroost:
    "heapsgo.referralOverview.share.Goldenroost",
  heapsgoReferralOverviewShareGeppetto:
    "heapsgo.referralOverview.share.Geppetto",
  heapsgoReferralOverviewShareGaodumpling:
    "heapsgo.referralOverview.share.Gaodumpling",
  heapsgoReferralOverviewShareFrederiksbergSmørrebrød:
    "heapsgo.referralOverview.share.Frederiksberg.Smørrebrød",
  heapsgoReferralOverviewShareFlyChicken:
    "heapsgo.referralOverview.share.FlyChicken",
  heapsgoReferralOverviewShareEvald: "heapsgo.referralOverview.share.Evald",
  heapsgoReferralOverviewShareDistrictTonkin:
    "heapsgo.referralOverview.share.DistrictTonkin",
  heapsgoReferralOverviewShareDiamondSlice:
    "heapsgo.referralOverview.share.DiamondSlice",
  heapsgoReferralOverviewShareDhaba: "heapsgo.referralOverview.share.Dhaba",
  heapsgoReferralOverviewShareDandelion:
    "heapsgo.referralOverview.share.Dandelion",
  heapsgoReferralOverviewShareChavez: "heapsgo.referralOverview.share.Chavez",
  heapsgoReferralOverviewShareCaspers: "heapsgo.referralOverview.share.Caspers",
  heapsgoReferralOverviewShareBurgerShack:
    "heapsgo.referralOverview.share.BurgerShack",
  heapsgoReferralOverviewShareBaryl: "heapsgo.referralOverview.share.Baryl",
  heapsgoReferralOverviewShareBanhBanh:
    "heapsgo.referralOverview.share.BanhBanh",
  heapsgoReferralOverviewShareBONES: "heapsgo.referralOverview.share.BONES",
  heapsgoReferralOverviewShareBADSHA: "heapsgo.referralOverview.share.BADSHA",
  heapsgoReferralOverviewShareANOTHERPIZZA:
    "heapsgo.referralOverview.share.ANOTHERPIZZA",
  heapsgoReferralOverviewShare: "heapsgo.referralOverview.share",
  heapsgoReferralOverviewDescriptionWefeatorganic:
    "heapsgo.referralOverview.description.wefeatorganic",
  heapsgoReferralOverviewDescriptionWefeat:
    "heapsgo.referralOverview.description.wefeat",
  heapsgoReferralOverviewDescriptionWedo:
    "heapsgo.referralOverview.description.wedo",
  heapsgoReferralOverviewDescriptionTsutsu:
    "heapsgo.referralOverview.description.tsutsu",
  heapsgoReferralOverviewDescriptionSmag:
    "heapsgo.referralOverview.description.smag",
  heapsgoReferralOverviewDescriptionPalaeo:
    "heapsgo.referralOverview.description.palaeo",
  heapsgoReferralOverviewDescriptionOlioli:
    "heapsgo.referralOverview.description.olioli",
  heapsgoReferralOverviewDescriptionMaexico:
    "heapsgo.referralOverview.description.maexico",
  heapsgoReferralOverviewDescriptionKcalfactory:
    "heapsgo.referralOverview.description.kcalfactory",
  heapsgoReferralOverviewDescriptionJagger:
    "heapsgo.referralOverview.description.jagger",
  heapsgoReferralOverviewDescriptionHumblepie:
    "heapsgo.referralOverview.description.humblepie",
  heapsgoReferralOverviewDescriptionHubb:
    "heapsgo.referralOverview.description.hubb",
  heapsgoReferralOverviewDescriptionGroed:
    "heapsgo.referralOverview.description.groed",
  heapsgoReferralOverviewDescriptionGorms:
    "heapsgo.referralOverview.description.gorms",
  heapsgoReferralOverviewDescriptionGarbanzo:
    "heapsgo.referralOverview.description.garbanzo",
  heapsgoReferralOverviewDescriptionFrankies:
    "heapsgo.referralOverview.description.frankies",
  heapsgoReferralOverviewDescriptionEdenjaxx:
    "heapsgo.referralOverview.description.edenjaxx",
  heapsgoReferralOverviewDescriptionCocorico:
    "heapsgo.referralOverview.description.cocorico",
  heapsgoReferralOverviewDescriptionCaspers:
    "heapsgo.referralOverview.description.caspers",
  heapsgoReferralOverviewDescriptionBuzzcph:
    "heapsgo.referralOverview.description.buzzcph",
  heapsgoReferralOverviewDescriptionBurgerbeast:
    "heapsgo.referralOverview.description.burgerbeast",
  heapsgoReferralOverviewDescriptionBoff:
    "heapsgo.referralOverview.description.boff",
  heapsgoReferralOverviewDescriptionBlokksmash:
    "heapsgo.referralOverview.description.blokksmash",
  heapsgoReferralOverviewDescriptionBiteline:
    "heapsgo.referralOverview.description.biteline",
  heapsgoReferralOverviewDescriptionBindia:
    "heapsgo.referralOverview.description.bindia",
  heapsgoReferralOverviewDescriptionWaldorfGroup:
    "heapsgo.referralOverview.description.Waldorf.Group",
  heapsgoReferralOverviewDescriptionTommis:
    "heapsgo.referralOverview.description.Tommis",
  heapsgoReferralOverviewDescriptionTheFatGreek:
    "heapsgo.referralOverview.description.TheFatGreek",
  heapsgoReferralOverviewDescriptionStrangas:
    "heapsgo.referralOverview.description.Strangas",
  heapsgoReferralOverviewDescriptionStacys:
    "heapsgo.referralOverview.description.Stacys",
  heapsgoReferralOverviewDescriptionShabaz:
    "heapsgo.referralOverview.description.Shabaz",
  heapsgoReferralOverviewDescriptionSandwichpigen:
    "heapsgo.referralOverview.description.Sandwichpigen",
  heapsgoReferralOverviewDescriptionSURTX:
    "heapsgo.referralOverview.description.SURT2",
  heapsgoReferralOverviewDescriptionRollneat:
    "heapsgo.referralOverview.description.Rollneat",
  heapsgoReferralOverviewDescriptionRaSushi:
    "heapsgo.referralOverview.description.RaSushi",
  heapsgoReferralOverviewDescriptionPureGreensClub:
    "heapsgo.referralOverview.description.PureGreensClub",
  heapsgoReferralOverviewDescriptionPicoPizza:
    "heapsgo.referralOverview.description.PicoPizza",
  heapsgoReferralOverviewDescriptionParadis:
    "heapsgo.referralOverview.description.Paradis",
  heapsgoReferralOverviewDescriptionPanzanella:
    "heapsgo.referralOverview.description.Panzanella",
  heapsgoReferralOverviewDescriptionPHAGO:
    "heapsgo.referralOverview.description.PHAGO",
  heapsgoReferralOverviewDescriptionOAKBERRY:
    "heapsgo.referralOverview.description.OAKBERRY",
  heapsgoReferralOverviewDescriptionNOAHS:
    "heapsgo.referralOverview.description.NOAHS",
  heapsgoReferralOverviewDescriptionMubanthai:
    "heapsgo.referralOverview.description.Mubanthai",
  heapsgoReferralOverviewDescriptionMaikai:
    "heapsgo.referralOverview.description.Maikai",
  heapsgoReferralOverviewDescriptionMadklubben:
    "heapsgo.referralOverview.description.Madklubben",
  heapsgoReferralOverviewDescriptionMaMeMi:
    "heapsgo.referralOverview.description.MaMeMi",
  heapsgoReferralOverviewDescriptionLighthouseburger:
    "heapsgo.referralOverview.description.Lighthouseburger",
  heapsgoReferralOverviewDescriptionLetzsushi:
    "heapsgo.referralOverview.description.Letzsushi",
  heapsgoReferralOverviewDescriptionKyllingCo:
    "heapsgo.referralOverview.description.KyllingCo",
  heapsgoReferralOverviewDescriptionKillerkebab:
    "heapsgo.referralOverview.description.Killerkebab",
  heapsgoReferralOverviewDescriptionIscafeen:
    "heapsgo.referralOverview.description.Iscafeen",
  heapsgoReferralOverviewDescriptionIRONWOK:
    "heapsgo.referralOverview.description.IRONWOK",
  heapsgoReferralOverviewDescriptionIKISUSHI:
    "heapsgo.referralOverview.description.IKISUSHI",
  heapsgoReferralOverviewDescriptionHellopasta:
    "heapsgo.referralOverview.description.Hellopasta",
  heapsgoReferralOverviewDescriptionGoldenroost:
    "heapsgo.referralOverview.description.Goldenroost",
  heapsgoReferralOverviewDescriptionGeppetto:
    "heapsgo.referralOverview.description.Geppetto",
  heapsgoReferralOverviewDescriptionGaodumpling:
    "heapsgo.referralOverview.description.Gaodumpling",
  heapsgoReferralOverviewDescriptionFrederiksbergSmørrebrød:
    "heapsgo.referralOverview.description.Frederiksberg.Smørrebrød",
  heapsgoReferralOverviewDescriptionFlyChicken:
    "heapsgo.referralOverview.description.FlyChicken",
  heapsgoReferralOverviewDescriptionEvald:
    "heapsgo.referralOverview.description.Evald",
  heapsgoReferralOverviewDescriptionDistrictTonkin:
    "heapsgo.referralOverview.description.DistrictTonkin",
  heapsgoReferralOverviewDescriptionDiamondSlice:
    "heapsgo.referralOverview.description.DiamondSlice",
  heapsgoReferralOverviewDescriptionDhaba:
    "heapsgo.referralOverview.description.Dhaba",
  heapsgoReferralOverviewDescriptionDandelion:
    "heapsgo.referralOverview.description.Dandelion",
  heapsgoReferralOverviewDescriptionChavez:
    "heapsgo.referralOverview.description.Chavez",
  heapsgoReferralOverviewDescriptionBurgerShack:
    "heapsgo.referralOverview.description.BurgerShack",
  heapsgoReferralOverviewDescriptionBaryl:
    "heapsgo.referralOverview.description.Baryl",
  heapsgoReferralOverviewDescriptionBanhBanh:
    "heapsgo.referralOverview.description.BanhBanh",
  heapsgoReferralOverviewDescriptionBONES:
    "heapsgo.referralOverview.description.BONES",
  heapsgoReferralOverviewDescriptionBADSHA:
    "heapsgo.referralOverview.description.BADSHA",
  heapsgoReferralOverviewDescriptionANOTHERPIZZA:
    "heapsgo.referralOverview.description.ANOTHERPIZZA",
  heapsgoReferralInvitetitleWedo: "heapsgo.referral.invitetitle.wedo",
  heapsgoReferralInvitetitleTsutsu: "heapsgo.referral.invitetitle.tsutsu",
  heapsgoReferralInvitetitleSmag: "heapsgo.referral.invitetitle.smag",
  heapsgoReferralInvitetitlePalaeo: "heapsgo.referral.invitetitle.palaeo",
  heapsgoReferralInvitetitleOlioli: "heapsgo.referral.invitetitle.olioli",
  heapsgoReferralInvitetitleMaexico: "heapsgo.referral.invitetitle.maexico",
  heapsgoReferralInvitetitleKcalfactory:
    "heapsgo.referral.invitetitle.kcalfactory",
  heapsgoReferralInvitetitleJagger: "heapsgo.referral.invitetitle.jagger",
  heapsgoReferralInvitetitleHumblepie: "heapsgo.referral.invitetitle.humblepie",
  heapsgoReferralInvitetitleGroed: "heapsgo.referral.invitetitle.groed",
  heapsgoReferralInvitetitleGorms: "heapsgo.referral.invitetitle.gorms",
  heapsgoReferralInvitetitleFrankies: "heapsgo.referral.invitetitle.frankies",
  heapsgoReferralInvitetitleEdenjaxx: "heapsgo.referral.invitetitle.edenjaxx",
  heapsgoReferralInvitetitleCocorico: "heapsgo.referral.invitetitle.cocorico",
  heapsgoReferralInvitetitleCaspers: "heapsgo.referral.invitetitle.caspers",
  heapsgoReferralInvitetitleBuzzcph: "heapsgo.referral.invitetitle.buzzcph",
  heapsgoReferralInvitetitleBurgerbeast:
    "heapsgo.referral.invitetitle.burgerbeast",
  heapsgoReferralInvitetitleBoff: "heapsgo.referral.invitetitle.boff",
  heapsgoReferralInvitetitleBlokksmash:
    "heapsgo.referral.invitetitle.blokksmash",
  heapsgoReferralInvitetitleBiteline: "heapsgo.referral.invitetitle.biteline",
  heapsgoReferralInvitetitleBindia: "heapsgo.referral.invitetitle.bindia",
  heapsgoReferralInvitetitleWaldorfGroup:
    "heapsgo.referral.invitetitle.Waldorf.Group",
  heapsgoReferralInvitetitleTommis: "heapsgo.referral.invitetitle.Tommis",
  heapsgoReferralInvitetitleTheFatGreek:
    "heapsgo.referral.invitetitle.TheFatGreek",
  heapsgoReferralInvitetitleStrangas: "heapsgo.referral.invitetitle.Strangas",
  heapsgoReferralInvitetitleStacys: "heapsgo.referral.invitetitle.Stacys",
  heapsgoReferralInvitetitleShabaz: "heapsgo.referral.invitetitle.Shabaz",
  heapsgoReferralInvitetitleSandwichpigen:
    "heapsgo.referral.invitetitle.Sandwichpigen",
  heapsgoReferralInvitetitleSURTX: "heapsgo.referral.invitetitle.SURT2",
  heapsgoReferralInvitetitleRollneat: "heapsgo.referral.invitetitle.Rollneat",
  heapsgoReferralInvitetitleRaSushi: "heapsgo.referral.invitetitle.RaSushi",
  heapsgoReferralInvitetitlePureGreensClub:
    "heapsgo.referral.invitetitle.PureGreensClub",
  heapsgoReferralInvitetitlePicoPizza: "heapsgo.referral.invitetitle.PicoPizza",
  heapsgoReferralInvitetitleParadis: "heapsgo.referral.invitetitle.Paradis",
  heapsgoReferralInvitetitlePanzanella:
    "heapsgo.referral.invitetitle.Panzanella",
  heapsgoReferralInvitetitlePHAGO: "heapsgo.referral.invitetitle.PHAGO",
  heapsgoReferralInvitetitleOAKBERRY: "heapsgo.referral.invitetitle.OAKBERRY",
  heapsgoReferralInvitetitleNOAHS: "heapsgo.referral.invitetitle.NOAHS",
  heapsgoReferralInvitetitleMubanthai: "heapsgo.referral.invitetitle.Mubanthai",
  heapsgoReferralInvitetitleMaikai: "heapsgo.referral.invitetitle.Maikai",
  heapsgoReferralInvitetitleMadklubben:
    "heapsgo.referral.invitetitle.Madklubben",
  heapsgoReferralInvitetitleMaMeMi: "heapsgo.referral.invitetitle.MaMeMi",
  heapsgoReferralInvitetitleLighthouseburger:
    "heapsgo.referral.invitetitle.Lighthouseburger",
  heapsgoReferralInvitetitleLetzsushi: "heapsgo.referral.invitetitle.Letzsushi",
  heapsgoReferralInvitetitleKyllingCo: "heapsgo.referral.invitetitle.KyllingCo",
  heapsgoReferralInvitetitleKillerkebab:
    "heapsgo.referral.invitetitle.Killerkebab",
  heapsgoReferralInvitetitleIscafeen: "heapsgo.referral.invitetitle.Iscafeen",
  heapsgoReferralInvitetitleIRONWOK: "heapsgo.referral.invitetitle.IRONWOK",
  heapsgoReferralInvitetitleIKISUSHI: "heapsgo.referral.invitetitle.IKISUSHI",
  heapsgoReferralInvitetitleHellopasta:
    "heapsgo.referral.invitetitle.Hellopasta",
  heapsgoReferralInvitetitleGoldenroost:
    "heapsgo.referral.invitetitle.Goldenroost",
  heapsgoReferralInvitetitleGeppetto: "heapsgo.referral.invitetitle.Geppetto",
  heapsgoReferralInvitetitleGaodumpling:
    "heapsgo.referral.invitetitle.Gaodumpling",
  heapsgoReferralInvitetitleFrederiksbergSmørrebrød:
    "heapsgo.referral.invitetitle.Frederiksberg.Smørrebrød",
  heapsgoReferralInvitetitleFlyChicken:
    "heapsgo.referral.invitetitle.FlyChicken",
  heapsgoReferralInvitetitleEvald: "heapsgo.referral.invitetitle.Evald",
  heapsgoReferralInvitetitleDistrictTonkin:
    "heapsgo.referral.invitetitle.DistrictTonkin",
  heapsgoReferralInvitetitleDiamondSlice:
    "heapsgo.referral.invitetitle.DiamondSlice",
  heapsgoReferralInvitetitleDhaba: "heapsgo.referral.invitetitle.Dhaba",
  heapsgoReferralInvitetitleDandelion: "heapsgo.referral.invitetitle.Dandelion",
  heapsgoReferralInvitetitleChavez: "heapsgo.referral.invitetitle.Chavez",
  heapsgoReferralInvitetitleBurgerShack:
    "heapsgo.referral.invitetitle.BurgerShack",
  heapsgoReferralInvitetitleBaryl: "heapsgo.referral.invitetitle.Baryl",
  heapsgoReferralInvitetitleBanhBanh: "heapsgo.referral.invitetitle.BanhBanh",
  heapsgoReferralInvitetitleBONES: "heapsgo.referral.invitetitle.BONES",
  heapsgoReferralInvitetitleBADSHA: "heapsgo.referral.invitetitle.BADSHA",
  heapsgoReferralInvitetitleANOTHERPIZZA:
    "heapsgo.referral.invitetitle.ANOTHERPIZZA",
  heapsgoReferralDescription: "heapsgo.referral.description",
  comboVerifyCodeSupport: "combo.verify.code.support",
  comboSubscriptionSuccessTitleWefeat: "combo.subscription.successTitle.wefeat",
  comboSubscriptionSuccessTitleWedo: "combo.subscription.successTitle.wedo",
  comboSubscriptionSuccessTitleTsutsu: "combo.subscription.successTitle.tsutsu",
  comboSubscriptionSuccessTitleSmag: "combo.subscription.successTitle.smag",
  comboSubscriptionSuccessTitlePalaeo: "combo.subscription.successTitle.palaeo",
  comboSubscriptionSuccessTitleOlioli: "combo.subscription.successTitle.olioli",
  comboSubscriptionSuccessTitleMaexico:
    "combo.subscription.successTitle.maexico",
  comboSubscriptionSuccessTitleKunguak:
    "combo.subscription.successTitle.kunguak",
  comboSubscriptionSuccessTitleKcalfactory:
    "combo.subscription.successTitle.kcalfactory",
  comboSubscriptionSuccessTitleJagger: "combo.subscription.successTitle.jagger",
  comboSubscriptionSuccessTitleHumblepie:
    "combo.subscription.successTitle.humblepie",
  comboSubscriptionSuccessTitleHubb: "combo.subscription.successTitle.hubb",
  comboSubscriptionSuccessTitleGroed: "combo.subscription.successTitle.groed",
  comboSubscriptionSuccessTitleGorms: "combo.subscription.successTitle.gorms",
  comboSubscriptionSuccessTitleGarbanzo:
    "combo.subscription.successTitle.garbanzo",
  comboSubscriptionSuccessTitleFrankies:
    "combo.subscription.successTitle.frankies",
  comboSubscriptionSuccessTitleEdenjaxx:
    "combo.subscription.successTitle.edenjaxx",
  comboSubscriptionSuccessTitleCocorico:
    "combo.subscription.successTitle.cocorico",
  comboSubscriptionSuccessTitleBuzzcph:
    "combo.subscription.successTitle.buzzcph",
  comboSubscriptionSuccessTitleBurgerbeast:
    "combo.subscription.successTitle.burgerbeast",
  comboSubscriptionSuccessTitleBoff: "combo.subscription.successTitle.boff",
  comboSubscriptionSuccessTitleBlokksmash:
    "combo.subscription.successTitle.blokksmash",
  comboSubscriptionSuccessTitleBiteline:
    "combo.subscription.successTitle.biteline",
  comboSubscriptionSuccessTitleBindia: "combo.subscription.successTitle.bindia",
  comboSubscriptionSuccessTitleWaldorfGroup:
    "combo.subscription.successTitle.Waldorf.Group",
  comboSubscriptionSuccessTitleTommis: "combo.subscription.successTitle.Tommis",
  comboSubscriptionSuccessTitleTheFatGreek:
    "combo.subscription.successTitle.TheFatGreek",
  comboSubscriptionSuccessTitleStrangas:
    "combo.subscription.successTitle.Strangas",
  comboSubscriptionSuccessTitleStacys: "combo.subscription.successTitle.Stacys",
  comboSubscriptionSuccessTitleShabaz: "combo.subscription.successTitle.Shabaz",
  comboSubscriptionSuccessTitleSandwichpigen:
    "combo.subscription.successTitle.Sandwichpigen",
  comboSubscriptionSuccessTitleSURTX: "combo.subscription.successTitle.SURT2",
  comboSubscriptionSuccessTitleRollneat:
    "combo.subscription.successTitle.Rollneat",
  comboSubscriptionSuccessTitleRaSushi:
    "combo.subscription.successTitle.RaSushi",
  comboSubscriptionSuccessTitlePureGreensClub:
    "combo.subscription.successTitle.PureGreensClub",
  comboSubscriptionSuccessTitlePicopizza:
    "combo.subscription.successTitle.Picopizza",
  comboSubscriptionSuccessTitleParadis:
    "combo.subscription.successTitle.Paradis",
  comboSubscriptionSuccessTitlePanzanella:
    "combo.subscription.successTitle.Panzanella",
  comboSubscriptionSuccessTitlePHAGO: "combo.subscription.successTitle.PHAGO",
  comboSubscriptionSuccessTitleOAKBERRY:
    "combo.subscription.successTitle.OAKBERRY",
  comboSubscriptionSuccessTitleNOAHS: "combo.subscription.successTitle.NOAHS",
  comboSubscriptionSuccessTitleMubanthai:
    "combo.subscription.successTitle.Mubanthai",
  comboSubscriptionSuccessTitleMaikai: "combo.subscription.successTitle.Maikai",
  comboSubscriptionSuccessTitleMadklubben:
    "combo.subscription.successTitle.Madklubben",
  comboSubscriptionSuccessTitleMaMeMi: "combo.subscription.successTitle.MaMeMi",
  comboSubscriptionSuccessTitleLighthouseburger:
    "combo.subscription.successTitle.Lighthouseburger",
  comboSubscriptionSuccessTitleLetzsushi:
    "combo.subscription.successTitle.Letzsushi",
  comboSubscriptionSuccessTitleKyllingCo:
    "combo.subscription.successTitle.KyllingCo",
  comboSubscriptionSuccessTitleKillerkebab:
    "combo.subscription.successTitle.Killerkebab",
  comboSubscriptionSuccessTitleIscafeen:
    "combo.subscription.successTitle.Iscafeen",
  comboSubscriptionSuccessTitleIRONWOK:
    "combo.subscription.successTitle.IRONWOK",
  comboSubscriptionSuccessTitleIKISUSHI:
    "combo.subscription.successTitle.IKISUSHI",
  comboSubscriptionSuccessTitleHellopasta:
    "combo.subscription.successTitle.Hellopasta",
  comboSubscriptionSuccessTitleGoldenroost:
    "combo.subscription.successTitle.Goldenroost",
  comboSubscriptionSuccessTitleGeppetto:
    "combo.subscription.successTitle.Geppetto",
  comboSubscriptionSuccessTitleGaodumpling:
    "combo.subscription.successTitle.Gaodumpling",
  comboSubscriptionSuccessTitleFrederiksbergSmørrebrød:
    "combo.subscription.successTitle.Frederiksberg.Smørrebrød",
  comboSubscriptionSuccessTitleFlyChicken:
    "combo.subscription.successTitle.FlyChicken",
  comboSubscriptionSuccessTitleEvald: "combo.subscription.successTitle.Evald",
  comboSubscriptionSuccessTitleDistrictTonkin:
    "combo.subscription.successTitle.DistrictTonkin",
  comboSubscriptionSuccessTitleDiamondSlice:
    "combo.subscription.successTitle.DiamondSlice",
  comboSubscriptionSuccessTitleDhaba: "combo.subscription.successTitle.Dhaba",
  comboSubscriptionSuccessTitleDandelion:
    "combo.subscription.successTitle.Dandelion",
  comboSubscriptionSuccessTitleChavez: "combo.subscription.successTitle.Chavez",
  comboSubscriptionSuccessTitleCaspers:
    "combo.subscription.successTitle.Caspers",
  comboSubscriptionSuccessTitleBurgerShack:
    "combo.subscription.successTitle.BurgerShack",
  comboSubscriptionSuccessTitleBuka: "combo.subscription.successTitle.Buka",
  comboSubscriptionSuccessTitleBaryl: "combo.subscription.successTitle.Baryl",
  comboSubscriptionSuccessTitleBanhBanh:
    "combo.subscription.successTitle.BanhBanh",
  comboSubscriptionSuccessTitleBONES: "combo.subscription.successTitle.BONES",
  comboSubscriptionSuccessTitleBADSHA: "combo.subscription.successTitle.BADSHA",
  comboSubscriptionSuccessTitleANOTHERPIZZA:
    "combo.subscription.successTitle.ANOTHERPIZZA",
  comboOrderChooseSubtextMadklubben: "combo.order.choose.subtext.madklubben",
  addressTooFarAway: "address.too.far.away",
  addressTooFarAwayWebSubtitle: "address.too.far.away.web.subtitle",
  asapNotAvailableSubtitle: "asap.not.available.subtitle",
  bonesCustomAddToCart: "bones.custom.add.to.cart",
  bonesCustomCartTitle: "bones.custom.cart.title",
  bonesCustomCheckoutTitle: "bones.custom.checkout.title",
  bonesCustomChooseOptions: "bones.custom.choose.options",
  bonesCustomComment: "bones.custom.comment",
  bonesCustomContactInfo: "bones.custom.contact.info",
  bonesCustomContinueShopping: "bones.custom.continue.shopping",
  bonesCustomContinueToCheckoutSubtitle:
    "bones.custom.continue.to.checkout.subtitle",
  bonesCustomContinueToCheckoutTitle: "bones.custom.continue.to.checkout.title",
  bonesCustomOpeningHours: "bones.custom.opening.hours",
  bonesCustomOrderDetailsTitle: "bones.custom.order.details.title",
  bonesCustomPickupLocation: "bones.custom.pickup.location",
  bonesCustomPlaceOrder: "bones.custom.place.order",
  bonesCustomQuantityTitle: "bones.custom.quantity.title",
  bonesCustomQuestionaire: "bones.custom.questionaire",
  bonesCustomStartTitle: "bones.custom.start.title",
  bonesCustomTermsPrefix: "bones.custom.terms.prefix",
  bonesCustomTermsSuffix: "bones.custom.terms.suffix",
  bonesCustomTotal: "bones.custom.total",
  bonesCustomUpsellPanelItemTitle: "bones.custom.upsell.panel.item.title",
  bonesCustomUpsellTitle: "bones.custom.upsell.title",
  bonesCustomUpsellsubTitle: "bones.custom.upsellsub.title",
  bonesCustomYourOrder: "bones.custom.your.order",
  buzzRidersDescription: "buzz.riders.description",
  buzzRidersTitle: "buzz.riders.title",
  capacityControlErrorMaxCapacityReached:
    "capacityControl.error.maxCapacityReached",
  capacityControlErrorMaxUnitsReached: "capacityControl.error.maxUnitsReached",
  capacityControlErrorNoTimeslotsAvailable:
    "capacityControl.error.noTimeslotsAvailable",
  capacityControlErrorSelectedTimeslotNotAvailable:
    "capacityControl.error.selectedTimeslotNotAvailable",
  cartButtonClear: "cart.button.clear",
  cartTitleMain: "cart.title.main",
  cartTitleProducts: "cart.title.products",
  cateringOrderSuccessSubtitle: "catering.order.success.subtitle",
  cateringOrderSuccessSubtitleObs: "catering.order.success.subtitle.obs",
  cateringRequestCateringOrder: "catering.request.catering.order",
  cateringRequestCateringOrderConfirm:
    "catering.request.catering.order.confirm",
  closedFutureInfoboxHeader: "closed.future.infobox.header",
  closedInfoboxHeader: "closed.infobox.header",
  closedTodayInfoboxHeader: "closed.today.infobox.header",
  comboAccept: "combo.accept",
  comboActivityDetails: "combo.activity.details",
  comboActivityEmpty: "combo.activity.empty",
  comboActivityOverview: "combo.activity.overview",
  comboAddAdult: "combo.add.adult",
  comboAddChild: "combo.add.child",
  comboAddingCardSubtitle: "combo.adding.card.subtitle",
  comboAddingCardTitle: "combo.adding.card.title",
  comboAdditionGroupSharedPriceDescriptionFree:
    "combo.addition.group.shared.price.description.free",
  comboAdditionGroupSharedPriceDescriptionFreePlural:
    "combo.addition.group.shared.price.description.free.plural",
  comboAdditionGroupSharedPriceDescriptionPriced:
    "combo.addition.group.shared.price.description.priced",
  comboAdditionGroupSharedPriceDescriptionPricedPlural:
    "combo.addition.group.shared.price.description.priced.plural",
  comboAddressesChange: "combo.addresses.change",
  comboAdults: "combo.adults",
  comboAnalytics: "combo.analytics",
  comboBeaconErrorBeen_in_backgroundBody:
    "combo.beacon.error.been_in_background.body",
  comboBeaconErrorBeen_in_backgroundHeader:
    "combo.beacon.error.been_in_background.header",
  comboBeaconErrorConnection_closedBody:
    "combo.beacon.error.connection_closed.body",
  comboBeaconErrorConnection_closedHeader:
    "combo.beacon.error.connection_closed.header",
  comboBluetoothMessage: "combo.bluetooth.message",
  comboBluetoothTitle: "combo.bluetooth.title",
  comboBonesOnlyInputsShowFamilyBirthdaysLabel:
    "combo.bones.only.inputs.show.family.birthdays.label",
  comboBuyVouchers: "combo.buy.vouchers",
  comboBuyVouchersConfirmed: "combo.buy.vouchers.confirmed",
  comboBuyVouchersConfirmedSubtitle: "combo.buy.vouchers.confirmed.subtitle",
  comboBuyVouchersCoolDownAmountLeft: "combo.buy.vouchers.coolDownAmountLeft",
  comboBuyVouchersCoolDownLimitedReached:
    "combo.buy.vouchers.coolDownLimitedReached",
  comboBuyVouchersCoolDownReached: "combo.buy.vouchers.coolDownReached",
  comboBuyVouchersFailed: "combo.buy.vouchers.failed",
  comboBuyVouchersFailedSubtext: "combo.buy.vouchers.failed.subtext",
  comboBuyVouchersPaymentMethodMissingDescription:
    "combo.buy.vouchers.paymentMethodMissing.description",
  comboBuyVouchersPaymentMethodMissingTitle:
    "combo.buy.vouchers.paymentMethodMissing.title",
  comboBuyVouchersSuccess: "combo.buy.vouchers.success",
  comboCardPayWithDiscount: "combo.card.payWithDiscount",
  comboCardRetryIn: "combo.card.retryIn",
  comboCartProductsRemovedSubtitle: "combo.cart.products.removed.subtitle",
  comboCartProductsRemovedTitle: "combo.cart.products.removed.title",
  comboCartShowOrder: "combo.cart.showOrder",
  comboCartsEmptySubtitle: "combo.carts.empty.subtitle",
  comboCartsEmptyTitle: "combo.carts.empty.title",
  comboCartsTitle: "combo.carts.title",
  comboCateringAndEvents: "combo.catering.and.events",
  comboCheckoutMyBenefitsTitle: "combo.checkout.my.benefits.title",
  comboCheckoutPaymentMessage: "combo.checkout.payment.message",
  comboCheckoutPaymentTitle: "combo.checkout.payment.title",
  comboCheckoutPreparingPayment: "combo.checkout.preparingPayment",
  comboCheckoutProductsUnavailableSubtitle:
    "combo.checkout.products.unavailable.subtitle",
  comboCheckoutProductsUnavailableTitle:
    "combo.checkout.products.unavailable.title",
  comboCheckoutTooBusy: "combo.checkout.tooBusy",
  comboCheckoutYourDetails: "combo.checkout.yourDetails",
  comboCheckoutYourDetailsEmailError: "combo.checkout.yourDetails.emailError",
  comboCheckoutYourDetailsEmailErrorValidate:
    "combo.checkout.yourDetails.emailErrorValidate",
  comboCheckoutYourDetailsFirstNameError:
    "combo.checkout.yourDetails.firstNameError",
  comboCheckoutYourDetailsLastNameError:
    "combo.checkout.yourDetails.lastNameError",
  comboCheckoutYourDetailsOnlyLettersAllowed:
    "combo.checkout.yourDetails.onlyLettersAllowed",
  comboCheckoutYourDetailsPhoneError: "combo.checkout.yourDetails.phoneError",
  comboChildren: "combo.children",
  comboChooseTime: "combo.choose.time",
  comboChooseTimeToContinue: "combo.choose.time.to.continue",
  comboCodeFailedSubtext: "combo.code.failed.subtext",
  comboCodeSubtitle: "combo.code.subtitle",
  comboCodeSuccessGiftcardSubtitle: "combo.code.success.giftcard.subtitle",
  comboCodeSuccessGiftcardTitle: "combo.code.success.giftcard.title",
  comboCodeSuccessGiftcardvoucherTitle:
    "combo.code.success.giftcardvoucher.title",
  comboCodeSuccessGiftcardvoucherTitlePlural:
    "combo.code.success.giftcardvoucher.title.plural",
  comboCodeSuccessSubtitle: "combo.code.success.subtitle",
  comboCodeSuccessSubtitlePlural: "combo.code.success.subtitle.plural",
  comboCodeSuccessTitle: "combo.code.success.title",
  comboCodeSuccessTitlePlural: "combo.code.success.title.plural",
  comboCodeTitle: "combo.code.title",
  comboCodeVoucherExpired: "combo.code.voucher.expired",
  comboContinueOrder: "combo.continue.order",
  comboCookiesDescription: "combo.cookies.description",
  comboCookiesInsuranceText: "combo.cookies.insurance.text",
  comboCookiesNecessary: "combo.cookies.necessary",
  comboCookiesPolicy: "combo.cookies.policy",
  comboCreateaccountBirthday: "combo.createaccount.birthday",
  comboCreateaccountBithdayValidation: "combo.createaccount.bithdayValidation",
  comboCreateaccountChatWithSupport: "combo.createaccount.chatWithSupport",
  comboCreateaccountEmail: "combo.createaccount.email",
  comboCreateaccountEmailSubtext: "combo.createaccount.email.subtext",
  comboCreateaccountEmailValidation: "combo.createaccount.emailValidation",
  comboCreateaccountEmptyValidation: "combo.createaccount.emptyValidation",
  comboCreateaccountExample: "combo.createaccount.example",
  comboCreateaccountFirst: "combo.createaccount.first",
  comboCreateaccountGetStarted: "combo.createaccount.getStarted",
  comboCreateaccountGetStartedTitle: "combo.createaccount.getStarted.title",
  comboCreateaccountHide: "combo.createaccount.hide",
  comboCreateaccountLast: "combo.createaccount.last",
  comboCreateaccountPassword: "combo.createaccount.password",
  comboCreateaccountPasswordValidation:
    "combo.createaccount.passwordValidation",
  comboCreateaccountPhone: "combo.createaccount.phone",
  comboCreateaccountPhoneSubtext: "combo.createaccount.phone.subtext",
  comboCreateaccountPhoneValidation: "combo.createaccount.phoneValidation",
  comboCreateaccountResendEmail: "combo.createaccount.resendEmail",
  comboCreateaccountShow: "combo.createaccount.show",
  comboCreateaccountStaffCardFieldTitle:
    "combo.createaccount.staffCardFieldTitle",
  comboCreateaccountStaffCardTitle: "combo.createaccount.staffCardTitle",
  comboCreateaccountVerifyEmail: "combo.createaccount.verifyEmail",
  comboCreateaccountVerifyEmailDetails:
    "combo.createaccount.verifyEmailDetails",
  comboDelivery: "combo.delivery",
  comboDeliveryDetails: "combo.delivery.details",
  comboDeliveryDetailsAddress: "combo.delivery.details.address",
  comboDeliveryDetailsChooseaddress: "combo.delivery.details.chooseaddress",
  comboDepositErrorChargeMessage: "combo.deposit.error.charge.message",
  comboDepositErrorChargeTitle: "combo.deposit.error.charge.title",
  comboDepositErrorLimitReachedMessage:
    "combo.deposit.error.limitReached.message",
  comboDepositErrorLimitReachedTitle: "combo.deposit.error.limitReached.title",
  comboDepositErrorNoCardSelectedMessage:
    "combo.deposit.error.noCardSelectedMessage",
  comboDepositErrorNoCardSelectedTitle:
    "combo.deposit.error.noCardSelectedTitle",
  comboDepositErrorNoMoneyMessage: "combo.deposit.error.noMoney.message",
  comboDepositErrorNoMoneyTitle: "combo.deposit.error.noMoney.title",
  comboDepositSuccessTitle: "combo.deposit.successTitle",
  comboDepositTopupsubtitle: "combo.deposit.topupsubtitle",
  comboDepositTopupsubtitleSecond: "combo.deposit.topupsubtitle.second",
  comboDepositTopupsubtitleThird: "combo.deposit.topupsubtitle.third",
  comboDepositTopuptitle: "combo.deposit.topuptitle",
  comboDetailsDescriptionReadMore: "combo.details.description.readMore",
  comboDownloadAppCta: "combo.download.app.cta",
  comboEditDetails: "combo.edit.details",
  comboEditDetailsAdditionalInfoHint: "combo.edit.details.additional.info.hint",
  comboEditDetailsAdditionalInfoSubtitle:
    "combo.edit.details.additional.info.subtitle",
  comboEditDetailsAddress: "combo.edit.details.address",
  comboEditDetailsAddressDelete: "combo.edit.details.address.delete",
  comboEditDetailsAddressEdit: "combo.edit.details.address.edit",
  comboEditDetailsAddressGeneralError:
    "combo.edit.details.address.generalError",
  comboEditDetailsAddressHint: "combo.edit.details.address.hint",
  comboEditDetailsAddressInfoTitle: "combo.edit.details.address.info.title",
  comboEditDetailsAddressInstructions:
    "combo.edit.details.address.instructions",
  comboEditDetailsAddressInstructionsSubtitle:
    "combo.edit.details.address.instructions.subtitle",
  comboEditDetailsAddressMissingCity: "combo.edit.details.address.missingCity",
  comboEditDetailsAddressMissingPostcode:
    "combo.edit.details.address.missingPostcode",
  comboEditDetailsAddressName: "combo.edit.details.address.name",
  comboEditDetailsAddressNameHint: "combo.edit.details.address.name.hint",
  comboEditDetailsAddressNameSubtitle:
    "combo.edit.details.address.name.subtitle",
  comboEditDetailsAddressSubtitle: "combo.edit.details.address.subtitle",
  comboEditDetailsAddressTitle: "combo.edit.details.address.title",
  comboEditDetailsChooseLocation: "combo.edit.details.choose.location",
  comboEditDetailsChooseLocationOnMap:
    "combo.edit.details.choose.locationOnMap",
  comboEditDetailsGuide: "combo.edit.details.guide",
  comboEditDetailsSearchAddressCurrentDescription:
    "combo.edit.details.search.address.current.description",
  comboEditDetailsSearchAddressMapDescription:
    "combo.edit.details.search.address.map.description",
  comboEditDetailsSearchAddressMapTitle:
    "combo.edit.details.search.address.map.title",
  comboEditDetailsSearchLocation: "combo.edit.details.search.location",
  comboErrorBluetoothPermissionBody: "combo.error.bluetooth.permission.body",
  comboErrorLocation_permissionBody: "combo.error.location_permission.body",
  comboFilterFilter: "combo.filter.filter",
  comboFiltersClearFilter: "combo.filters.clear.filter",
  comboFiltersFrom: "combo.filters.from",
  comboFiltersPrice: "combo.filters.price",
  comboFiltersResults: "combo.filters.results",
  comboFiltersTo: "combo.filters.to",
  comboFormsDidYouMean: "combo.forms.did.you.mean",
  comboGeneralErrorMessage: "combo.general.error.message",
  comboGoToRestaurants: "combo.go.to.restaurants",
  comboHomeMemberBenefit: "combo.home.memberBenefit",
  comboHomeOffer: "combo.home.offer",
  comboHomeOfferClickToBuy: "combo.home.offer.clickToBuy",
  comboHowManyDoYouWant: "combo.how.many.do.you.want",
  comboIngredients: "combo.ingredients",
  comboInputsBirthdayError: "combo.inputs.birthday.error",
  comboInputsBirthdayLabel: "combo.inputs.birthday.label",
  comboInputsBirthdayPlaceholder: "combo.inputs.birthday.placeholder",
  comboInputsFamilyMembersError: "combo.inputs.family.members.error",
  comboInputsFavoriteRestaurantError: "combo.inputs.favorite.restaurant.error",
  comboInputsFavoriteRestaurantLabel: "combo.inputs.favorite.restaurant.label",
  comboInputsFavoriteRestaurantPlaceholder:
    "combo.inputs.favorite.restaurant.placeholder",
  comboInputsNameError: "combo.inputs.name.error",
  comboInputsNameLabel: "combo.inputs.name.label",
  comboInputsNamePlaceholder: "combo.inputs.name.placeholder",
  comboLoginErrordismiss: "combo.login.errordismiss",
  comboLoginErrormessage: "combo.login.errormessage",
  comboLoginErrortitle: "combo.login.errortitle",
  comboLoginPasswordHint: "combo.login.password.hint",
  comboLoyaltyBenefitAddedToOrderSubtitle:
    "combo.loyalty.benefit.added.to.order.subtitle",
  comboLoyaltyBenefitAddedToOrderTitle:
    "combo.loyalty.benefit.added.to.order.title",
  comboLoyaltyBenefitAddedToWallet: "combo.loyalty.benefit.added.to.wallet",
  comboLoyaltyBenefitAddedToWalletSubtitle:
    "combo.loyalty.benefit.added.to.wallet.subtitle",
  comboLoyaltyBenefitAddedToWalletTip:
    "combo.loyalty.benefit.added.to.wallet.tip",
  comboLoyaltyBenefitCurrencyMismatch:
    "combo.loyalty.benefit.currency.mismatch",
  comboLoyaltyGeneralCodePlaceholder: "combo.loyalty.general.code.placeholder",
  comboManage: "combo.manage",
  comboMarketing: "combo.marketing",
  comboMembershipSignupAddcreditcard: "combo.membership.signup.addcreditcard",
  comboMembershipSignupReferralCodeConfirmation:
    "combo.membership.signup.referral.code.confirmation",
  comboMembershipSignupReferralCodeConfirmationSubtitle:
    "combo.membership.signup.referral.code.confirmationSubtitle",
  comboMembershipSignupReferralCodeDismiss:
    "combo.membership.signup.referral.code.dismiss",
  comboMembershipSignupReferralCodeSubmit:
    "combo.membership.signup.referral.code.submit",
  comboMembershipSignupReferralCodeSuccess:
    "combo.membership.signup.referral.code.success",
  comboMembershipSignupReferralCodeSuccessSubtext:
    "combo.membership.signup.referral.code.success.subtext",
  comboMembershipSignupReferralCodeSuccessTitle:
    "combo.membership.signup.referral.code.success.title",
  comboMembershipSignupReferralCodeTitle:
    "combo.membership.signup.referral.code.title",
  comboMembershipSignupReferralCodeTitleSubtext:
    "combo.membership.signup.referral.code.title.subtext",
  comboMembershipTermsMarketing: "combo.membership.terms.marketing",
  comboMembershipTermsReadAndAccept: "combo.membership.terms.readAndAccept",
  comboMenuCards: "combo.menu.cards",
  comboMenuHome: "combo.menu.home",
  comboMenuMe: "combo.menu.me",
  comboMenuOrder: "combo.menu.order",
  comboMenuRewards: "combo.menu.rewards",
  comboMissing: "combo.missing",
  comboNoBenefitsAvailable: "combo.no.benefits.available",
  comboNoMoreTimeslotsSubtitle: "combo.no.more.timeslots.subtitle",
  comboNoMoreTimeslotsTitle: "combo.no.more.timeslots.title",
  comboNotLoggedInDescription: "combo.not.logged.in.description",
  comboNotLoggedInTitle: "combo.not.logged.in.title",
  comboNutrition: "combo.nutrition",
  comboOnboardingSkip: "combo.onboarding.skip",
  comboOpeningHoursOn: "combo.opening.hours.on",
  comboOpeninghours: "combo.openinghours",
  comboOrderActiveOrders: "combo.order.active.orders",
  comboOrderActiveOrdersPlural: "combo.order.active.orders.plural",
  comboOrderAddProduct: "combo.order.addProduct",
  comboOrderAddcomment: "combo.order.addcomment",
  comboOrderAddcommentSubtitle: "combo.order.addcomment.subtitle",
  comboOrderAddcommentTitle: "combo.order.addcomment.title",
  comboOrderAdditions: "combo.order.additions",
  comboOrderAdditionsInfoMax: "combo.order.additions.info.max",
  comboOrderAdditionsInfoMaxMore: "combo.order.additions.info.max.more",
  comboOrderAdditionsInfoMaxreached: "combo.order.additions.info.maxreached",
  comboOrderAdditionsInfoMin: "combo.order.additions.info.min",
  comboOrderAdditionsNone: "combo.order.additions.none",
  comboOrderAdditionsNoneSelected: "combo.order.additions.noneSelected",
  comboOrderAdditionsSome: "combo.order.additions.some",
  comboOrderAdditionsSubtext: "combo.order.additions.subtext",
  comboOrderAllergens: "combo.order.allergens",
  comboOrderCancelMessage: "combo.order.cancel.message",
  comboOrderCancelStay: "combo.order.cancel.stay",
  comboOrderCancelTitle: "combo.order.cancel.title",
  comboOrderCancelYes: "combo.order.cancel.yes",
  comboOrderCartChooseAdditions: "combo.order.cart.chooseAdditions",
  comboOrderCartEmpty: "combo.order.cart.empty",
  comboOrderCheckAdditions: "combo.order.checkAdditions",
  comboOrderCheckout: "combo.order.checkout",
  comboOrderCheckoutAddDiscount: "combo.order.checkout.addDiscount",
  comboOrderCheckoutClosedForOrders: "combo.order.checkout.closedForOrders",
  comboOrderCheckoutComment: "combo.order.checkout.comment",
  comboOrderCheckoutDeliveryExtraFee: "combo.order.checkout.deliveryExtraFee",
  comboOrderCheckoutDeliveryExtraFeeDetails:
    "combo.order.checkout.deliveryExtraFeeDetails",
  comboOrderCheckoutDeliveryMinimumPriceNotMetDescription:
    "combo.order.checkout.deliveryMinimumPriceNotMet.description",
  comboOrderCheckoutDeliveryMinimumPriceNotMetDetails:
    "combo.order.checkout.deliveryMinimumPriceNotMet.details",
  comboOrderCheckoutDeliveryMinimumPriceNotMetTitle:
    "combo.order.checkout.deliveryMinimumPriceNotMet.title",
  comboOrderCheckoutLoyaltyAdd: "combo.order.checkout.loyalty.add",
  comboOrderCheckoutLoyaltyAddSubtext:
    "combo.order.checkout.loyalty.add.subtext",
  comboOrderCheckoutLoyaltyTitle: "combo.order.checkout.loyalty.title",
  comboOrderCheckoutMinDeliveryMessage:
    "combo.order.checkout.min.delivery.message",
  comboOrderCheckoutMinimumPriceNotMet:
    "combo.order.checkout.minimumPriceNotMet",
  comboOrderCheckoutOutsideOpeningHours:
    "combo.order.checkout.outsideOpeningHours",
  comboOrderCheckoutOutsideOpeningHoursTitle:
    "combo.order.checkout.outsideOpeningHoursTitle",
  comboOrderCheckoutOutsideOpeningHoursWithDate:
    "combo.order.checkout.outsideOpeningHoursWithDate",
  comboOrderCheckoutPaymentAdd: "combo.order.checkout.payment.add",
  comboOrderCheckoutPaymentTitle: "combo.order.checkout.payment.title",
  comboOrderCheckoutPaymentTotal: "combo.order.checkout.payment.total",
  comboOrderCheckoutProductNotAvailable:
    "combo.order.checkout.productNotAvailable",
  comboOrderCheckoutProductsTitle: "combo.order.checkout.products.title",
  comboOrderCheckoutRemoveBasketItemBody:
    "combo.order.checkout.removeBasketItemBody",
  comboOrderCheckoutRemoveBasketItemHeader:
    "combo.order.checkout.removeBasketItemHeader",
  comboOrderCheckoutRemoveBasketItemRemove:
    "combo.order.checkout.removeBasketItemRemove",
  comboOrderCheckoutRequestTimedOut: "combo.order.checkout.requestTimedOut",
  comboOrderCheckoutSubtotal: "combo.order.checkout.subtotal",
  comboOrderCheckoutSumup: "combo.order.checkout.sumup",
  comboOrderCheckoutTitle: "combo.order.checkout.title",
  comboOrderCheckoutTotal: "combo.order.checkout.total",
  comboOrderCheckoutViewAll: "combo.order.checkout.viewAll",
  comboOrderCheckoutVoucherNotEligible:
    "combo.order.checkout.voucherNotEligible",
  comboOrderCheckoutVoucherNotEligibleTitle:
    "combo.order.checkout.voucherNotEligible.title",
  comboOrderCheckoutVoucherNotEligibleTemplateTitle:
    "combo.order.checkout.voucherNotEligibleTemplate.title",
  comboOrderChoose: "combo.order.choose",
  comboOrderChooseDelivery: "combo.order.choose.delivery",
  comboOrderChoosePickup: "combo.order.choose.pickup",
  comboOrderChooseSubtext: "combo.order.choose.subtext",
  comboOrderChooseSubtextPlural: "combo.order.choose.subtext.plural",
  comboOrderClickToOrderAsap: "combo.order.clickToOrderAsap",
  comboOrderClickToPreOrder: "combo.order.clickToPreOrder",
  comboOrderConfirmation: "combo.order.confirmation",
  comboOrderCopy: "combo.order.copy",
  comboOrderCopyCta: "combo.order.copy.cta",
  comboOrderCustomEstimateConfirmationOnEmail:
    "combo.order.customEstimate.confirmationOnEmail",
  comboOrderDeliveryAddressChange: "combo.order.delivery.address.change",
  comboOrderDeliveryAddressTo: "combo.order.delivery.address.to",
  comboOrderDeliveryAddressOutsideRange:
    "combo.order.delivery.addressOutsideRange",
  comboOrderDeliveryChange: "combo.order.delivery.change",
  comboOrderDeliveryChooseAddress: "combo.order.delivery.chooseAddress",
  comboOrderDeliveryFirst: "combo.order.delivery.first",
  comboOrderDeliveryLocation: "combo.order.delivery.location",
  comboOrderDeliveryNotpossible: "combo.order.delivery.notpossible",
  comboOrderDeliveryNotpossibleBody: "combo.order.delivery.notpossibleBody",
  comboOrderDeliveryNotpossibleToAddress:
    "combo.order.delivery.notpossibleToAddress",
  comboOrderDeliverySecond: "combo.order.delivery.second",
  comboOrderDeliveryTime: "combo.order.delivery.time",
  comboOrderDeliveryTo: "combo.order.delivery.to",
  comboOrderDeliveryTooFarAway: "combo.order.delivery.tooFarAway",
  comboOrderDeliveryToobusy: "combo.order.delivery.toobusy",
  comboOrderDeliveryWithDistance: "combo.order.delivery.withDistance",
  comboOrderDeliveryComingSoon: "combo.order.deliveryComingSoon",
  comboOrderDetails: "combo.order.details",
  comboOrderDetailsAsap: "combo.order.details.asap",
  comboOrderDetailsDelivery: "combo.order.details.delivery",
  comboOrderDetailsDeliveryChange: "combo.order.details.delivery.change",
  comboOrderDetailsDeliverySubtext: "combo.order.details.delivery.subtext",
  comboOrderDetailsEatIn: "combo.order.details.eatIn",
  comboOrderDetailsNoTimeslotsForDayErrorMessage:
    "combo.order.details.no.timeslots.for.day.errorMessage",
  comboOrderDetailsPickup: "combo.order.details.pickup",
  comboOrderDetailsPickupSubtext: "combo.order.details.pickup.subtext",
  comboOrderDetailsPreorder: "combo.order.details.preorder",
  comboOrderDetailsSubtotal: "combo.order.details.subtotal",
  comboOrderDetailsTitle: "combo.order.details.title",
  comboOrderDetailsTitleHow: "combo.order.details.title.how",
  comboOrderDetailsTitleWhere: "combo.order.details.title.where",
  comboOrderDetailsTotalPaid: "combo.order.details.totalPaid",
  comboOrderGoBack: "combo.order.goBack",
  comboOrderGoToPayment: "combo.order.goToPayment",
  comboOrderLoyaltyApplied: "combo.order.loyalty.applied",
  comboOrderMoreInfo: "combo.order.moreInfo",
  comboOrderNoMoreTimeslotsOnDateDeliveryTitle:
    "combo.order.noMoreTimeslotsOnDateDelivery.title",
  comboOrderNoMoreTimeslotsOnDatePickupTitle:
    "combo.order.noMoreTimeslotsOnDatePickup.title",
  comboOrderNoMoreTimeslotsTodayMessage:
    "combo.order.noMoreTimeslotsToday.message",
  comboOrderNoMoreTimeslotsTodayTitle: "combo.order.noMoreTimeslotsToday.title",
  comboOrderNoMoreTimeslotsTodayDeliveryTitle:
    "combo.order.noMoreTimeslotsTodayDelivery.title",
  comboOrderNoMoreTimeslotsTodayPickupTitle:
    "combo.order.noMoreTimeslotsTodayPickup.title",
  comboOrderPickupFrom: "combo.order.pickup.from",
  comboOrderPickupLocation: "combo.order.pickup.location",
  comboOrderPickupNotpossible: "combo.order.pickup.notpossible",
  comboOrderPickupTime: "combo.order.pickup.time",
  comboOrderProcessing: "combo.order.processing",
  comboOrderQuantity: "combo.order.quantity",
  comboOrderRemove: "combo.order.remove",
  comboOrderSmileyReport: "combo.order.smileyReport",
  comboOrderStateAccepted: "combo.order.state.accepted",
  comboOrderStateDeliveredDelivery: "combo.order.state.delivered.delivery",
  comboOrderStateDeliveredPickup: "combo.order.state.delivered.pickup",
  comboOrderStateInDelivery: "combo.order.state.in.delivery",
  comboOrderStateNotPaid: "combo.order.state.not.paid",
  comboOrderStateReady: "combo.order.state.ready",
  comboOrderStateReceived: "combo.order.state.received",
  comboOrderStatusDelivered: "combo.order.status.delivered",
  comboOrderStatusDelivery: "combo.order.status.delivery",
  comboOrderStatusDeliveryTime: "combo.order.status.deliveryTime",
  comboOrderStatusOrderAcceptedDetails:
    "combo.order.status.orderAcceptedDetails",
  comboOrderStatusOrderAcceptedInfoDelivery:
    "combo.order.status.orderAcceptedInfo.delivery",
  comboOrderStatusOrderAcceptedInfoPickup:
    "combo.order.status.orderAcceptedInfo.pickup",
  comboOrderStatusOrderDeliveredDetails:
    "combo.order.status.orderDeliveredDetails",
  comboOrderStatusOrderDeliveredTitle: "combo.order.status.orderDeliveredTitle",
  comboOrderStatusOrderInDeliveryDetails:
    "combo.order.status.orderInDeliveryDetails",
  comboOrderStatusOrderReadyDetails: "combo.order.status.orderReadyDetails",
  comboOrderStatusOrderReadyTitle: "combo.order.status.orderReadyTitle",
  comboOrderStatusOrderReceivedDetailsDelivered:
    "combo.order.status.orderReceivedDetails.delivered",
  comboOrderStatusOrderReceivedDetailsPickup:
    "combo.order.status.orderReceivedDetails.pickup",
  comboOrderStatusOrderReceivedInfo: "combo.order.status.orderReceivedInfo",
  comboOrderStatusOrderReceivedTitle: "combo.order.status.orderReceivedTitle",
  comboOrderStatusOrderRejectedDetails:
    "combo.order.status.orderRejectedDetails",
  comboOrderStatusOrderRejectedInfo: "combo.order.status.orderRejectedInfo",
  comboOrderStatusOrderRejectedTitle: "combo.order.status.orderRejectedTitle",
  comboOrderStatusPickupTime: "combo.order.status.pickupTime",
  comboOrderStatusReady: "combo.order.status.ready",
  comboOrderStatusRejected: "combo.order.status.rejected",
  comboOrderStatusStepfour: "combo.order.status.stepfour",
  comboOrderStatusStepone: "combo.order.status.stepone",
  comboOrderStatusStepthree: "combo.order.status.stepthree",
  comboOrderStatusSteptwo: "combo.order.status.steptwo",
  comboOrderUpdateOrder: "combo.order.updateOrder",
  comboOrderUpdateProduct: "combo.order.updateProduct",
  comboOrderUpsellTitle: "combo.order.upsell.title",
  comboPasswordResetTokenExpired: "combo.password.reset.token.expired",
  comboPasswordResetTokenNotFound: "combo.password.reset.token.notFound",
  comboPayAddCreditCard: "combo.pay.addCreditCard",
  comboPayAddCreditCardDescription: "combo.pay.addCreditCard.description",
  comboPayAddCreditCardDetails: "combo.pay.addCreditCard.details",
  comboPayAddCreditCardInviteCode: "combo.pay.addCreditCard.inviteCode",
  comboPayAddCreditCardLoading: "combo.pay.addCreditCard.loading",
  comboPayAddCreditCardSuccess: "combo.pay.addCreditCard.success",
  comboPayAddMemberCard: "combo.pay.addMemberCard",
  comboPayBeep: "combo.pay.beep",
  comboPayCardInfoClick: "combo.pay.cardInfoClick",
  comboPayCardPay: "combo.pay.cardPay",
  comboPayChangePayment: "combo.pay.changePayment",
  comboPayCreditcardSubtext: "combo.pay.creditcard.subtext",
  comboPayExpires: "combo.pay.expires",
  comboPayPayAmount: "combo.pay.payAmount",
  comboPayPaying: "combo.pay.paying",
  comboPayPayingSubtitle: "combo.pay.paying.subtitle",
  comboPayPayingWith: "combo.pay.payingWith",
  comboPaySecureTitle: "combo.pay.secureTitle",
  comboPaySecuredByStripe: "combo.pay.securedByStripe",
  comboPaySubtitle: "combo.pay.subtitle",
  comboPayVenue: "combo.pay.venue",
  comboPaymentBartenderConnecting: "combo.payment.bartender.connecting",
  comboPaymentBartenderConnectingError:
    "combo.payment.bartender.connecting.error",
  comboPaymentBartenderSkipping: "combo.payment.bartender.skipping",
  comboPaymentBartenderSubtitle: "combo.payment.bartender.subtitle",
  comboPaymentBartenderTitle: "combo.payment.bartender.title",
  comboPaymentBoxFound: "combo.payment.boxFound",
  comboPaymentCardconfirmed: "combo.payment.cardconfirmed",
  comboPaymentClose: "combo.payment.close",
  comboPaymentDone: "combo.payment.done",
  comboPaymentEnterCode: "combo.payment.enterCode",
  comboPaymentEnterCodeDialogMessage: "combo.payment.enterCodeDialog.message",
  comboPaymentEnterCodeDialogTitle: "combo.payment.enterCodeDialog.title",
  comboPaymentErrorCardExpired: "combo.payment.error.card.expired",
  comboPaymentErrorCardInvalid: "combo.payment.error.card.invalid",
  comboPaymentErrorCardInvalidCvc: "combo.payment.error.card.invalid.cvc",
  comboPaymentErrorCardLost: "combo.payment.error.card.lost",
  comboPaymentErrorCard_not_foundBody:
    "combo.payment.error.card_not_found.body",
  comboPaymentErrorCard_not_foundHeader:
    "combo.payment.error.card_not_found.header",
  comboPaymentErrorClosedBody: "combo.payment.error.closed.body",
  comboPaymentErrorClosedHeader: "combo.payment.error.closed.header",
  comboPaymentErrorDoNotHonor: "combo.payment.error.do.not.honor",
  comboPaymentErrorGenericBody: "combo.payment.error.generic.body",
  comboPaymentErrorGenericHeader: "combo.payment.error.generic.header",
  comboPaymentErrorInsufficientFunds: "combo.payment.error.insufficient.funds",
  comboPaymentErrorInsufficient_fundsBody:
    "combo.payment.error.insufficient_funds.body",
  comboPaymentErrorInsufficient_fundsHeader:
    "combo.payment.error.insufficient_funds.header",
  comboPaymentErrorMissing_payment_idBody:
    "combo.payment.error.missing_payment_id.body",
  comboPaymentErrorMissing_payment_idHeader:
    "combo.payment.error.missing_payment_id.header",
  comboPaymentErrorNo_connectionBody: "combo.payment.error.no_connection.body",
  comboPaymentErrorNo_connectionHeader:
    "combo.payment.error.no_connection.header",
  comboPaymentErrorNoconnectionHeader:
    "combo.payment.error.noconnection.header",
  comboPaymentErrorPayment_cancelledBody:
    "combo.payment.error.payment_cancelled.body",
  comboPaymentErrorPayment_cancelledHeader:
    "combo.payment.error.payment_cancelled.header",
  comboPaymentErrorPos_disconnectedBody:
    "combo.payment.error.pos_disconnected.body",
  comboPaymentErrorPos_disconnectedHeader:
    "combo.payment.error.pos_disconnected.header",
  comboPaymentMethods: "combo.payment.methods",
  comboPaymentPaymentConfirmed: "combo.payment.payment.confirmed",
  comboPaymentPaymentconfirmed: "combo.payment.paymentconfirmed",
  comboPaymentRangeinstructions: "combo.payment.rangeinstructions",
  comboPaymentRangescanning: "combo.payment.rangescanning",
  comboPaymentVoucher: "combo.payment.voucher",
  comboPaymentVoucherSuccess: "combo.payment.voucher.success",
  comboPaymentZeroPaymentTitle: "combo.payment.zero.payment.title",
  comboPickerToday: "combo.picker.today",
  comboPickup: "combo.pickup",
  comboProfileAddCard: "combo.profile.addCard",
  comboProfileBuy: "combo.profile.buy",
  comboProfileChangesAjour: "combo.profile.changes.ajour",
  comboProfileChangesNotPossible: "combo.profile.changes.not.possible",
  comboProfileCreditCards: "combo.profile.creditCards",
  comboProfileDeleteprofile: "combo.profile.deleteprofile",
  comboProfileEnterPromoCode: "combo.profile.enterPromoCode",
  comboProfileHeapsgo: "combo.profile.heapsgo",
  comboProfileHistory: "combo.profile.history",
  comboProfileLegal: "combo.profile.legal",
  comboProfileMemberCards: "combo.profile.memberCards",
  comboProfileMyaddresses: "combo.profile.myaddresses",
  comboProfileNoMemberCardsMessage: "combo.profile.noMemberCardsMessage",
  comboProfileNoMemberCardsTitle: "combo.profile.noMemberCardsTitle",
  comboProfilePaymentCards: "combo.profile.paymentCards",
  comboProfilePoweredBy: "combo.profile.poweredBy",
  comboProfileRedirection: "combo.profile.redirection",
  comboProfileRemoveCard: "combo.profile.removeCard",
  comboProfileRemoveCardAlertMessage: "combo.profile.removeCardAlertMessage",
  comboProfileRemoveCardAlertTitle: "combo.profile.removeCardAlertTitle",
  comboProfileRiders: "combo.profile.riders",
  comboProfileSave: "combo.profile.save",
  comboProfileSeniority: "combo.profile.seniority",
  comboProfileSignout: "combo.profile.signout",
  comboProfileSupport: "combo.profile.support",
  comboProfileSupportEmail: "combo.profile.support.email",
  comboProfileSupportWeb: "combo.profile.support.web",
  comboProfileTerms: "combo.profile.terms",
  comboProfileVerifyPhone: "combo.profile.verifyPhone",
  comboRecommendedProductsTitle: "combo.recommended.products.title",
  comboReferralReadMore: "combo.referral.readMore",
  comboReferralToptitle: "combo.referral.toptitle",
  comboReset: "combo.reset",
  comboResetPasswordCheckEmail: "combo.resetPassword.checkEmail",
  comboResetPasswordSuccessDescription:
    "combo.resetPassword.successDescription",
  comboResetPasswordTitle: "combo.resetPassword.title",
  comboResetPasswordErrorMessage: "combo.resetPasswordError.message",
  comboRestaurant: "combo.restaurant",
  comboRestaurantClosedForOrders: "combo.restaurant.closed.for.orders",
  comboRestaurantOpenForOrders: "combo.restaurant.open.for.orders",
  comboRewardsXXXcompleted: "combo.rewards.100completed",
  comboRewardsActive: "combo.rewards.active",
  comboRewardsAddToWallet: "combo.rewards.addToWallet",
  comboRewardsChallenge: "combo.rewards.challenge",
  comboRewardsClaimed: "combo.rewards.claimed",
  comboRewardsClaimedCheckmark: "combo.rewards.claimedCheckmark",
  comboRewardsClaimedRewards: "combo.rewards.claimedRewards",
  comboRewardsClaimedRewardsDescription:
    "combo.rewards.claimedRewardsDescription",
  comboRewardsClickBelowToUnlock: "combo.rewards.clickBelowToUnlock",
  comboRewardsClickHereToJoin: "combo.rewards.clickHereToJoin",
  comboRewardsCompleted: "combo.rewards.completed",
  comboRewardsCompletedGiftWaiting: "combo.rewards.completed.giftWaiting",
  comboRewardsCongrats: "combo.rewards.congrats",
  comboRewardsDialogJoinAccept: "combo.rewards.dialogJoinAccept",
  comboRewardsDialogJoinDescription: "combo.rewards.dialogJoinDescription",
  comboRewardsDialogJoinTitle: "combo.rewards.dialogJoinTitle",
  comboRewardsExpired: "combo.rewards.expired",
  comboRewardsExpires: "combo.rewards.expires",
  comboRewardsGoalOrders: "combo.rewards.goalOrders",
  comboRewardsGoalOrdersPlural: "combo.rewards.goalOrders.plural",
  comboRewardsInactive: "combo.rewards.inactive",
  comboRewardsMarketingTerms: "combo.rewards.marketingTerms",
  comboRewardsReadyToBeClaimed: "combo.rewards.readyToBeClaimed",
  comboRewardsRemainingOrdersToComplete:
    "combo.rewards.remainingOrdersToComplete",
  comboRewardsReward: "combo.rewards.reward",
  comboRewardsRewardTitle: "combo.rewards.reward.title",
  comboRewardsRewardDetailsClaimed: "combo.rewards.rewardDetails.claimed",
  comboRewardsRewardDetailsCompleteToReceive:
    "combo.rewards.rewardDetails.completeToReceive",
  comboRewardsSectionCompletedSubtitle:
    "combo.rewards.sectionCompletedSubtitle",
  comboRewardsSectionCompletedTitle: "combo.rewards.sectionCompletedTitle",
  comboRewardsSectionExpiredSubtitle: "combo.rewards.sectionExpiredSubtitle",
  comboRewardsSectionExpiredTitle: "combo.rewards.sectionExpiredTitle",
  comboRewardsStatus: "combo.rewards.status",
  comboRewardsSubtitle: "combo.rewards.subtitle",
  comboRewardsTermsReadAndAccept: "combo.rewards.termsReadAndAccept",
  comboRewardsUnlockReward: "combo.rewards.unlockReward",
  comboRewardsUnlockingReward: "combo.rewards.unlockingReward",
  comboRewardsValidity: "combo.rewards.validity",
  comboRewardsValidityDay: "combo.rewards.validity.day",
  comboRewardsValidityDayPlural: "combo.rewards.validity.day.plural",
  comboRewardsValidityMonth: "combo.rewards.validity.month",
  comboRewardsValidityMonthPlural: "combo.rewards.validity.month.plural",
  comboRewardsValidityYear: "combo.rewards.validity.year",
  comboRewardsValidityYearPlural: "combo.rewards.validity.year.plural",
  comboRewardsVoucher: "combo.rewards.voucher",
  comboRewardsVoucherInfo: "combo.rewards.voucherInfo",
  comboRewardsYourStatus: "combo.rewards.yourStatus",
  comboRidersClaim: "combo.riders.claim",
  comboRidersClaimingDelivery: "combo.riders.claimingDelivery",
  comboRidersClickToChooseShop: "combo.riders.clickToChooseShop",
  comboRidersCustomer: "combo.riders.customer",
  comboRidersDeliveries: "combo.riders.deliveries",
  comboRidersDeliveringDelivery: "combo.riders.deliveringDelivery",
  comboRidersDeliveryAtCustomer: "combo.riders.deliveryAtCustomer",
  comboRidersDeliveryClaimed: "combo.riders.deliveryClaimed",
  comboRidersDeliveryClaimingFailed: "combo.riders.deliveryClaimingFailed",
  comboRidersDeliveryDelivered: "combo.riders.deliveryDelivered",
  comboRidersDeliveryUnclaimedSuccess: "combo.riders.deliveryUnclaimedSuccess",
  comboRidersDistance: "combo.riders.distance",
  comboRidersMarkDelivered: "combo.riders.markDelivered",
  comboRidersMarkUnclaimed: "combo.riders.markUnclaimed",
  comboRidersMyDeliveries: "combo.riders.myDeliveries",
  comboRidersPhoneNumber: "combo.riders.phoneNumber",
  comboRidersPickUpAtRestaurant: "combo.riders.pickUpAtRestaurant",
  comboRidersScanClaimDeliverDescription:
    "combo.riders.scanClaimDeliver.description",
  comboRidersScanClaimDeliverTitle: "combo.riders.scanClaimDeliver.title",
  comboRidersScanToClaimOrder: "combo.riders.scanToClaimOrder",
  comboRidersShowOrder: "combo.riders.showOrder",
  comboRidersStaffOnly: "combo.riders.staffOnly",
  comboRidersStatus: "combo.riders.status",
  comboRidersTitle: "combo.riders.title",
  comboRidersUnClaimingDelivery: "combo.riders.unClaimingDelivery",
  comboRidersViewAllOrders: "combo.riders.viewAllOrders",
  comboSearchNoResult: "combo.search.no.result",
  comboSearchPlaceholder: "combo.search.placeholder",
  comboSendEmail: "combo.send.email",
  comboSharedPriceAdditionsMissingAddProduct:
    "combo.shared.price.additions.missing.add.product",
  comboSharedPriceAdditionsMissingSubtitle:
    "combo.shared.price.additions.missing.subtitle",
  comboSharedPriceAdditionsMissingTitle:
    "combo.shared.price.additions.missing.title",
  comboSharedPriceAdditionsMissingUpdateProduct:
    "combo.shared.price.additions.missing.update.product",
  comboSignUpTermsMissingAccept: "combo.sign.up.terms.missing.accept",
  comboSignupBirthdayHint: "combo.signup.birthday.hint",
  comboSignupConfirmYourEmail: "combo.signup.confirmYourEmail",
  comboSignupEmailHint: "combo.signup.email.hint",
  comboSignupErrorNoTerms: "combo.signup.error.noTerms",
  comboSignupErrorTryAgainTitle: "combo.signup.error.tryAgainTitle",
  comboSignupFirstNameHint: "combo.signup.firstName.hint",
  comboSignupLastNameHint: "combo.signup.lastName.hint",
  comboSignupPasswordHint: "combo.signup.password.hint",
  comboSignupPhoneHint: "combo.signup.phone.hint",
  comboSoldOut: "combo.sold.out",
  comboSubscriptionSuccessTitleWefeatorganic:
    "combo.subscription.successTitle.wefeatorganic",
  comboTicketsAdd: "combo.tickets.add",
  comboTicketsAddCard: "combo.tickets.addCard",
  comboTicketsExpires: "combo.tickets.expires",
  comboToday: "combo.today",
  comboTomorrow: "combo.tomorrow",
  comboTripleupAddFunds: "combo.tripleup.addFunds",
  comboUserMissingSignUpDescriptionLogIn:
    "combo.user.missing.sign.up.description.log.in",
  comboUserMissingSignUpDescriptionSignUp:
    "combo.user.missing.sign.up.description.sign.up",
  comboUserMissingSignUpTitleLogIn: "combo.user.missing.sign.up.title.log.in",
  comboUserMissingSignUpTitleSignUp: "combo.user.missing.sign.up.title.sign.up",
  comboVerifyCodeResendButton: "combo.verify.code.resendButton",
  comboVerifyCodeSubtitle: "combo.verify.code.subtitle",
  comboVerifyCodeTitle: "combo.verify.code.title",
  comboVerifyCountriesSearchPlaceholder:
    "combo.verify.countries.search.placeholder",
  comboVerifyCountriesSubtitle: "combo.verify.countries.subtitle",
  comboVerifyCountriesTitle: "combo.verify.countries.title",
  comboVerifyDescription: "combo.verify.description",
  comboVerifyPhoneTitle: "combo.verify.phoneTitle",
  comboVerifyStatusIncorrectSubtitle: "combo.verify.status.incorrect.subtitle",
  comboVerifyStatusIncorrectTitle: "combo.verify.status.incorrect.title",
  comboVerifyStatusIncorrectTryAgain: "combo.verify.status.incorrect.tryAgain",
  comboVerifyStatusValidatedTitle: "combo.verify.status.validated.title",
  comboVerifyStatusValidatingTitle: "combo.verify.status.validating.title",
  comboVerifySubtitle: "combo.verify.subtitle",
  comboVerifyTitle: "combo.verify.title",
  comboVerifyVerifyButton: "combo.verify.verifyButton",
  comboVersion_checkBody: "combo.version_check.body",
  comboVersion_checkCancel: "combo.version_check.cancel",
  comboVersion_checkHeader: "combo.version_check.header",
  comboVersion_checkOk: "combo.version_check.ok",
  comboVoucherClaim: "combo.voucher.claim",
  comboVoucherQuantity: "combo.voucher.quantity",
  comboVoucherstackBalance: "combo.voucherstack.balance",
  comboVoucherstackPaymentstatus: "combo.voucherstack.paymentstatus",
  comboWalletAddpayment: "combo.wallet.addpayment",
  comboWalletAddvoucher: "combo.wallet.addvoucher",
  comboWalletAddvoucherQuantity: "combo.wallet.addvoucher.quantity",
  comboWalletCardSubtextfamily: "combo.wallet.card.subtextfamily",
  comboWalletCardlabel: "combo.wallet.cardlabel",
  comboWalletCardsubtext: "combo.wallet.cardsubtext",
  comboWalletCardtagline: "combo.wallet.cardtagline",
  comboWalletEnterPromoCodeMessage: "combo.wallet.enterPromoCode.message",
  comboWalletSubtitleBalancecard: "combo.wallet.subtitle.balancecard",
  comboWalletSuccessMessage: "combo.wallet.success.message",
  comboWalletSuccessMessagePlural: "combo.wallet.success.message.plural",
  comboWalletSuccessTitle: "combo.wallet.success.title",
  comboWalletUpdate: "combo.wallet.update",
  comboWalletVerifyPhoneNumberButton: "combo.wallet.verifyPhoneNumber.button",
  comboWalletVerifyPhoneNumberDescription:
    "combo.wallet.verifyPhoneNumber.description",
  comboWalletVerifyPhoneNumberTitle: "combo.wallet.verifyPhoneNumber.title",
  comboWalletVoucheradded: "combo.wallet.voucheradded",
  comboWalletVoucherleft: "combo.wallet.voucherleft",
  comboWalletVouchersOrUseWithBeacon: "combo.wallet.vouchers.orUseWithBeacon",
  comboWalletVouchersProcessing: "combo.wallet.vouchers.processing",
  comboWalletVouchersSwipeToUse: "combo.wallet.vouchers.swipeToUse",
  comboWalletVouchersUseVoucher: "combo.wallet.vouchers.useVoucher",
  comboWalletVouchersVoucherSpentMessage:
    "combo.wallet.vouchers.voucherSpentMessage",
  comboWalletVouchersVoucherSpentTitle:
    "combo.wallet.vouchers.voucherSpentTitle",
  comboWalletVouchersubtitle: "combo.wallet.vouchersubtitle",
  comboWebFooterUsefulLinks: "combo.web.footer.useful.links",
  comboWelcomeLogind: "combo.welcome.logind",
  comboYourProfile: "combo.your.profile",
  commonMissingSharedSelectionsTitile:
    "common.missing.shared.selections.titile",
  confirmCodeValidatingCode: "confirm.code.validating.code",
  confirmPaymentPopupCancel: "confirm.payment.popup.cancel",
  confirmPaymentPopupOrder: "confirm.payment.popup.order",
  confirmPaymentPopupPrompt: "confirm.payment.popup.prompt",
  confirmPaymentPopupSubtitle: "confirm.payment.popup.subtitle",
  confirmPaymentPopupTitle: "confirm.payment.popup.title",
  cookies: "cookies",
  ctaAcceptAll: "cta.accept.all",
  ctaSavePreferences: "cta.save.preferences",
  deliveryChooseAddress: "delivery.choose.address",
  groedGroed: "groed.groed",
  groedGroedFamily: "groed.groedFamily",
  groedSlogan: "groed.slogan",
  heapsgoAddToTableAddProductConfirm: "heapsgo.addToTable.addProductConfirm",
  heapsgoAddToTableAddProductDescription:
    "heapsgo.addToTable.addProductDescription",
  heapsgoAddToTableAddProductTitle: "heapsgo.addToTable.addProductTitle",
  heapsgoAddToTableAddToTableTitle: "heapsgo.addToTable.addToTableTitle",
  heapsgoAddToTableCtaTitle: "heapsgo.addToTable.ctaTitle",
  heapsgoAddToTableEnterTableNumerDescription:
    "heapsgo.addToTable.enterTableNumerDescription",
  heapsgoAddToTableEnterTableNumerTitle:
    "heapsgo.addToTable.enterTableNumerTitle",
  heapsgoAddToTableMyTableCta: "heapsgo.addToTable.myTableCta",
  heapsgoAddToTableMyTableTitle: "heapsgo.addToTable.myTableTitle",
  heapsgoAddToTableOrderReceivedDescription:
    "heapsgo.addToTable.orderReceivedDescription",
  heapsgoAddToTableOrderReceivedTitle: "heapsgo.addToTable.orderReceivedTitle",
  heapsgoAddToTablePlaceOrderDescription:
    "heapsgo.addToTable.placeOrderDescription",
  heapsgoAddToTablePlaceOrderTitle: "heapsgo.addToTable.placeOrderTitle",
  heapsgoAddToTablePlayOrderPayTitle: "heapsgo.addToTable.playOrderPayTitle",
  heapsgoAddToTableScanQr: "heapsgo.addToTable.scanQr",
  heapsgoAddToTableTableNumber: "heapsgo.addToTable.tableNumber",
  heapsgoAddToTableVenueListDescription:
    "heapsgo.addToTable.venueListDescription",
  heapsgoAddToTableVenueListTitle: "heapsgo.addToTable.venueListTitle",
  heapsgoCreditCardErrorAddedbyAnotherUser:
    "heapsgo.creditCard.error.addedbyAnotherUser",
  heapsgoPaymentPaymentCompleted: "heapsgo.payment.paymentCompleted",
  heapsgoTableBookingVenueListMessage: "heapsgo.tableBooking.venueList.message",
  homeCtaGamesCardTitle: "home.cta.games.cardTitle",
  homeSectionTitleInvite: "home.section.title.invite",
  homeSectionTitleNews: "home.section.title.news",
  homeSectionTitleOffers: "home.section.title.offers",
  homeSectionTitleRewards: "home.section.title.rewards",
  homeTitle: "home.title",
  inputCommentLabel: "input.comment.label",
  inputCommentPlaceholder: "input.comment.placeholder",
  inputConfirmCodeEnterValue: "input.confirm.code.enter.value",
  inputConfirmCodeNotNumber: "input.confirm.code.not.number",
  inputEannumberNoInput: "input.eannumber.no.input",
  inputEannumberNotValid: "input.eannumber.not.valid",
  inputEmailErrorMessage: "input.email.error.message",
  inputEmailNoInput: "input.email.no.input",
  inputFirstNameErrorMessage: "input.first.name.error.message",
  inputLastNameErrorMessage: "input.last.name.error.message",
  inputOptional: "input.optional",
  inputPasswordErrorMessage: "input.password.error.message",
  inputPasswordNoInput: "input.password.no.input",
  inputPhonenumberNoInput: "input.phonenumber.no.input",
  inputPhonenumberNotValid: "input.phonenumber.not.valid",
  inputRequired: "input.required",
  inputTermsNotChecked: "input.terms.not.checked",
  inputZipNotValid: "input.zip.not.valid",
  missingAddressPromptSubtitle: "missing.address.prompt.subtitle",
  missingAddressPromptTitle: "missing.address.prompt.title",
  missingTablePromptSubtitle: "missing.table.prompt.subtitle",
  missingTablePromptTitle: "missing.table.prompt.title",
  networkLossHeader: "network.loss.header",
  networkLossRefresh: "network.loss.refresh",
  networkLossSubtitle: "network.loss.subtitle",
  newAdditionsMaxNotSatisfied: "new.additions.max.not.satisfied",
  newAdditionsMaxReached: "new.additions.max.reached",
  newAdditionsMinNotSatisfied: "new.additions.min.not.satisfied",
  newAdditionsMultiManyToMany: "new.additions.multi.many.to.many",
  newAdditionsMultiZeroToMany: "new.additions.multi.zero.to.many",
  newAdditionsSingle: "new.additions.single",
  newAdditionsSinglePlural: "new.additions.single.plural",
  nextAvailableTime: "next.available.time",
  nightpayBenefitsSynchronizing: "nightpay.benefits.synchronizing",
  nightpayMembershipInviteCode: "nightpay.membership.inviteCode",
  nightpayPaymentTitleText: "nightpay.payment.titleText",
  nightpayPaymentHistoryCampaignBonus: "nightpay.paymentHistory.campaignBonus",
  nightpayPaymentHistoryCreditCard: "nightpay.paymentHistory.creditCard",
  nightpayPaymentHistoryDeposit: "nightpay.paymentHistory.deposit",
  nightpayPaymentHistoryDepositAccount:
    "nightpay.paymentHistory.depositAccount",
  nightpayPaymentHistoryNotAvailable: "nightpay.paymentHistory.notAvailable",
  nightpayPaymentHistorySubscription: "nightpay.paymentHistory.subscription",
  nightpayPaymentHistoryTicketsSpenta: "nightpay.paymentHistory.ticketsSpenta",
  nightpayPaymentHistoryTicketsSpentaPlural:
    "nightpay.paymentHistory.ticketsSpenta.plural",
  nightpayPaymentHistoryTripleUpAccount:
    "nightpay.paymentHistory.tripleUpAccount",
  nightpayPaymentHistoryWithdrawal: "nightpay.paymentHistory.withdrawal",
  nightpayProfileRegisterBeaconSuccessTitle:
    "nightpay.profile.registerBeacon.success.title",
  nightpayReferralApplyErrorAlreadyUsed:
    "nightpay.referralApplyError.alreadyUsed",
  nightpayReferralApplyErrorEmpty: "nightpay.referralApplyError.empty",
  nightpayReferralApplyErrorMaxReached:
    "nightpay.referralApplyError.maxReached",
  nightpayReferralApplyErrorNotActive: "nightpay.referralApplyError.notActive",
  nightpayReferralApplyErrorNotEligible:
    "nightpay.referralApplyError.notEligible",
  nightpayReferralApplyErrorNotFound: "nightpay.referralApplyError.notFound",
  nightpayReferralApplyErrorNotValid: "nightpay.referralApplyError.notValid",
  nightpayReferralOverviewInviteCode: "nightpay.referralOverview.inviteCode",
  nightpayReferralOverviewNumberOfFriends:
    "nightpay.referralOverview.numberOfFriends",
  nightpayReferralOverviewRegistrationsTitle:
    "nightpay.referralOverview.registrationsTitle",
  paymentComboTimoutCtaTitle: "payment.combo.timout.cta.title",
  paymentTimedOut: "payment.timed.out",
  popUpDeliverymethodSubtitle: "pop.up.deliverymethod.subtitle",
  popupDeliverymethodTitle: "popup.deliverymethod.title",
  profileAnonymizeReqestBody: "profile.anonymizeReqest.body",
  profileAnonymizeReqestCancel: "profile.anonymizeReqest.cancel",
  profileAnonymizeReqestProceed: "profile.anonymizeReqest.proceed",
  profileAnonymizeReqestTitle: "profile.anonymizeReqest.title",
  promptAddAddressSubtitle: "prompt.add.address.subtitle",
  promptAddAddressTitle: "prompt.add.address.title",
  referralCtaAction: "referral.cta.action",
  startCreateProfile: "start.createProfile",
  vatNumber: "vat.number",
  venueDetailsClosedOpeningSoon: "venueDetails.closedOpeningSoon",
  venuedetailsClosed: "venuedetails.closed",
  venuedetailsClosingAt: "venuedetails.closingAt",
  venuedetailsDeliveryMinimumOrder: "venuedetails.deliveryMinimumOrder",
  venuedetailsDeliveryOptionsAnd: "venuedetails.deliveryOptions.and",
  venuedetailsDeliveryOptionsDelivery: "venuedetails.deliveryOptions.delivery",
  venuedetailsDeliveryOptionsEatIn: "venuedetails.deliveryOptions.eatIn",
  venuedetailsDeliveryOptionsEatInChooseTable:
    "venuedetails.deliveryOptions.eatIn.chooseTable",
  venuedetailsDeliveryOptionsEatInChooseTableFooter:
    "venuedetails.deliveryOptions.eatIn.chooseTable.footer",
  venuedetailsDeliveryOptionsPickup: "venuedetails.deliveryOptions.pickup",
  venuedetailsDeliveryOptionsPickupDelivery:
    "venuedetails.deliveryOptions.pickupDelivery",
  venuedetailsDeliveryStartingPrice: "venuedetails.deliveryStartingPrice",
  walletTitleAdd: "wallet.title.add",
  walletTitleCreditCards: "wallet.title.creditCards",
  walletTitleDiscountCards: "wallet.title.discountCards",
  walletTitleTopUpCards: "wallet.title.topUpCards",
  walletTitleVouchers: "wallet.title.vouchers",
  walletVouchersCtaDescription: "wallet.vouchers.cta.description",
  walletVouchersCtaTitle: "wallet.vouchers.cta.title",
  webAddAddressAddressMissing: "web.add.address.address.missing",
  webAddAddressCityMissing: "web.add.address.city.missing",
  webAddAddressInstructionsMissing: "web.add.address.instructions.missing",
  webAddAddressPostcodeMissing: "web.add.address.postcode.missing",
  webAddCardFailed: "web.add.card.failed",
  webAddressIncomplete: "web.address.incomplete",
  webCartEmpty: "web.cart.empty",
  webCheckoutLoyaltyApplied: "web.checkout.loyalty.applied",
  webCheckoutLoyaltyExplain: "web.checkout.loyalty.explain",
  webCheckoutManagePaymentCards: "web.checkout.manage.payment.cards",
  webCheckoutMethodTitle: "web.checkout.method.title",
  webCheckoutNoloyalty: "web.checkout.noloyalty",
  webCheckoutPayWithCard: "web.checkout.pay.with.card",
  webCheckoutSecurelyPayment: "web.checkout.securely.payment",
  webCheckoutYourDetails: "web.checkout.your.details",
  webChoose: "web.choose",
  webChooseDay: "web.choose.day",
  webChooseDayInputLabel: "web.choose.day.input.label",
  webChooseLanguage: "web.choose.language",
  webChooseTimeInputLabel: "web.choose.time.input.label",
  webConfirmCodeCodeNotFound: "web.confirm.code.code.not.found",
  webConfirmCodeCodeUserExists: "web.confirm.code.code.user.exists",
  webCookiePreferencesSubtitle: "web.cookie.preferences.subtitle",
  webCookiePreferencesTitle: "web.cookie.preferences.title",
  webCouldNotSaveCard: "web.could.not.save.card",
  webCreditCardPay: "web.credit.card.pay",
  webDeliverymethodHow: "web.deliverymethod.how",
  webDeliverymethodWhere: "web.deliverymethod.where",
  webEanAttention: "web.ean.attention",
  webEanAttentionPlaceholder: "web.ean.attention.placeholder",
  webEanCity: "web.ean.city",
  webEanCityPlaceholder: "web.ean.city.placeholder",
  webEanEanNumber: "web.ean.ean.number",
  webEanEanNumberPlaceholder: "web.ean.ean.number.placeholder",
  webEanInstitutionName: "web.ean.institution.name",
  webEanInstitutionNamePlaceholder: "web.ean.institution.name.placeholder",
  webEanPay: "web.ean.pay",
  webEanPrivate: "web.ean.private",
  webEanPublic: "web.ean.public",
  webEanTitle: "web.ean.title",
  webEanZip: "web.ean.zip",
  webEanZipPlaceholder: "web.ean.zip.placeholder",
  webEntercodeCodeAlreadyUsed: "web.entercode.code.already.used",
  webEntercodeCodeNotFound: "web.entercode.code.not.found",
  webEntercodeMaximumExceeded: "web.entercode.maximum.exceeded",
  webEntercodeOrderAlreadyPlaced: "web.entercode.order.already.placed",
  webEntercodeUserAlreadyVerified: "web.entercode.user.already.verified",
  webEntercodeUserNotVerified: "web.entercode.user.not.verified",
  webExpectedReadyTimeEatIn: "web.expected.ready.time.eatIn",
  webExpectedReadyTimePickup: "web.expected.ready.time.pickup",
  webExpectedReadyTimePickupInterval: "web.expected.ready.time.pickup.interval",
  webForgotpasswordButtoncta: "web.forgotpassword.buttoncta",
  webForgotpasswordSubtitle: "web.forgotpassword.subtitle",
  webInputCodeLabel: "web.input.code.label",
  webInputCodePlaceholder: "web.input.code.placeholder",
  webLoginFailedLogin: "web.login.failed.login",
  webLoginNoaccount: "web.login.noaccount",
  webNoLoyaltySubtitle: "web.no.loyalty.subtitle",
  webNotavailable: "web.notavailable",
  webOrderAccepted: "web.order.accepted",
  webOrderAcceptedDeliverySubtitle: "web.order.accepted.delivery.subtitle",
  webOrderAcceptedSubtitle: "web.order.accepted.subtitle",
  webOrderAndPay: "web.order.and.pay",
  webOrderDelivered: "web.order.delivered",
  webOrderDeliveredSubtitle: "web.order.delivered.subtitle",
  webOrderDetailsAsapOrPreorderMissing:
    "web.order.details.asap.or.preorder.missing",
  webOrderDetailsDate: "web.order.details.date",
  webOrderDetailsDeliveryAddressMissing:
    "web.order.details.delivery.address.missing",
  webOrderDetailsOrderId: "web.order.details.order.id",
  webOrderDetailsOrderStatus: "web.order.details.order.status",
  webOrderDetailsOrderType: "web.order.details.order.type",
  webOrderDetailsTimeMissing: "web.order.details.time.missing",
  webOrderEatInDeliveredOrderStatus: "web.order.eat.in.delivered.order.status",
  webOrderEatInDeliveredOrderStatusSubtitle:
    "web.order.eat.in.delivered.order.status.subtitle",
  webOrderExpectedDelivery: "web.order.expected.delivery",
  webOrderPickedUp: "web.order.picked.up",
  webOrderPickedUpOrderStatus: "web.order.picked.up.order.status",
  webOrderPickedUpSubtitle: "web.order.picked.up.subtitle",
  webOrderReady: "web.order.ready",
  webOrderReadyInRestaurant: "web.order.ready.in.restaurant",
  webOrderReadyInRestaurantSubtitle: "web.order.ready.in.restaurant.subtitle",
  webOrderReadySubtitle: "web.order.ready.subtitle",
  webOrderReceived: "web.order.received",
  webOrderReceivedCtatext: "web.order.received.ctatext",
  webOrderReceivedInRestaurant: "web.order.received.in.restaurant",
  webOrderReceivedOrderStatusSubtitle:
    "web.order.received.order.status.subtitle",
  webOrderReceivedSubtitle: "web.order.received.subtitle",
  webOrderStatusDefault: "web.order.status.default",
  webOrderStatusEatInReadyTime: "web.order.status.eat.in.ready.time",
  webOrderStatusExpectedDeliveryTime: "web.order.status.expected.delivery.time",
  webOrderStatusExpectedReadyForPickUp:
    "web.order.status.expected.ready.for.pick.up",
  webOrderStatusHasBeenPickedUp: "web.order.status.has.been.picked.up",
  webOrderStatusOrderIsRejected: "web.order.status.order.is.rejected",
  webOrderStatusPickUpTime: "web.order.status.pick.up.time",
  webOrderStatusRejectedSubtitle: "web.order.status.rejected.subtitle",
  webOrderStatusRejectedTitle: "web.order.status.rejected.title",
  webOrderStatusSeeDetails: "web.order.status.see.details",
  webOrderStatusTitle: "web.order.status.title",
  webOrderStatusUntilExpectedPickUp: "web.order.status.until.expected.pick.up",
  webOrderTotal: "web.order.total",
  webOrderUnderway: "web.order.underway",
  webOrderUnderwaySubtitle: "web.order.underway.subtitle",
  webPayment: "web.payment",
  webPaymentCanceling: "web.payment.canceling",
  webPaymentCancelingDescription: "web.payment.canceling.description",
  webPaymentFailed: "web.payment.failed",
  webPaymentGoogleAppleSubtitle: "web.payment.google.apple.subtitle",
  webPaymentSubtitle: "web.payment.subtitle",
  webPreorderSubtitle: "web.preorder.subtitle",
  webPrivacy: "web.privacy",
  webResetPasswordCta: "web.reset.password.cta",
  webRestaurantClosed: "web.restaurant.closed",
  webRestaurantInfo: "web.restaurant.info",
  webRestaurantOpen: "web.restaurant.open",
  webRestaurantOpensat: "web.restaurant.opensat",
  webRestaurantToday: "web.restaurant.today",
  webRestaurantTomorrow: "web.restaurant.tomorrow",
  webSeeTerms: "web.see.terms",
  webSignUpFailed: "web.sign.up.failed",
  webSignupExistingaccount: "web.signup.existingaccount",
  webSignupMarketing: "web.signup.marketing",
  webTerms: "web.terms",
  webTermsNotChecked: "web.terms.not.checked",
  webViewproducts: "web.viewproducts",
}
